(function () {
  'use strict';

  var selectors = {
    drawer: '[data-drawer]',
    drawerOpen: '[data-drawer-open]',
    drawerClose: '[data-drawer-close]',
    drawerOverlay: '[data-drawer-overlay]',
    cartDrawer: '[data-cart-drawer]',
    cartDrawerOpen: '[data-cart-drawer-open]',
    cartDrawerClose: '[data-cart-drawer-close]',
    predictiveWrapper: '[data-predictive-search-wrapper]',
    searchSheet: '[data-search-sheet]',
    searchSheetOpen: '[data-search-sheet-open]',
    searchSheetClose: '[data-search-sheet-close]',
    predictiveInput: '[data-predictive-search-input]',
    predictiveResults: '[data-predictive-search-results]',
    searchClear: '[data-search-clear]',
    productForm: '[data-product-form]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    productFormError: '[data-product-form-error]',
    rail: '[data-product-rail]',
    railViewport: '[data-rail-viewport]',
    railPrev: '[data-rail-prev]',
    railNext: '[data-rail-next]',
    wishlistButton: '[data-wishlist-button]',
    wishlistRemove: '[data-wishlist-remove]',
    wishlistCount: '[data-wishlist-count]',
    wishlistPage: '[data-wishlist-page]',
    wishlistGrid: '[data-wishlist-grid]',
    wishlistEmpty: '[data-wishlist-empty]',
    wishlistStatus: '[data-wishlist-status]',
    hero: '[data-y10-hero]',
    heroSlide: '[data-y10-hero-slide]',
    heroPrev: '[data-y10-hero-prev]',
    heroNext: '[data-y10-hero-next]',
    heroDot: '[data-y10-hero-dot]',
    featuredProducts: '[data-featured-products]',
    featuredProductsTab: '[data-featured-products-tab]',
    featuredProductsPanel: '[data-featured-products-panel]',
    featuredProductsRail: '[data-featured-products-rail]',
    featuredProductsViewport: '[data-featured-products-viewport]',
    featuredProductsPrev: '[data-featured-products-prev]',
    featuredProductsNext: '[data-featured-products-next]',
    featuredProductsDots: '[data-featured-products-dots]',
    collectionFilterOpen: '[data-collection-filter-open]',
    collectionFilterClose: '[data-collection-filter-close]',
    collectionFilterDrawer: '[data-collection-filter-drawer]',
    collectionSortSelect: '[data-collection-sort-select]',
    collectionGrid: '[data-collection-grid]',
    collectionViewButton: '[data-collection-view-button]',
    loadMoreButton: '[data-load-more-button]',
    productGallery: '[data-product-gallery]',
    productGalleryThumb: '[data-product-gallery-thumb]',
    productGallerySlide: '[data-product-gallery-slide]',
    productGalleryZoom: '[data-product-gallery-zoom]',
    mainProduct: '[data-main-product]',
    productVariantState: '[data-product-variant-state]',
    productVariantId: '[data-product-variant-id]',
    selectedOptionName: '[data-selected-option-name]',
    stickyAtc: '[data-sticky-atc]',
    stickyAtcButton: '[data-sticky-atc-button]',
    shareButton: '[data-share-button]',
    productRecommendations: '[data-product-recommendations]',
    recentlyViewed: '[data-recently-viewed]',
    recentlyViewedGrid: '[data-recently-viewed-grid]',
    productDetails: '[data-product-details]',
    detailsTrigger: '[data-details-trigger]',
    detailsPanel: '[data-details-panel]',
    searchPage: '[data-search-page]',
    recentSearchesSection: '[data-recent-searches-section]',
    recentSearchesList: '[data-recent-searches-list]',
    recentSearchesClear: '[data-recent-searches-clear]',
    cartPage: '[data-cart-page]',
    cartNote: '[data-cart-note]',
    brandsDirectory: '[data-brands-directory]',
    brandCard: '[data-brand-card]',
    brandSearchInput: '[data-brand-search-input]',
    brandSearchClear: '[data-brand-search-clear]',
    brandLetter: '[data-brand-letter]',
    brandFilter: '[data-brand-filter]',
    brandStatus: '[data-brand-status]',
    brandsEmpty: '[data-brands-empty]',
    brandClearAll: '[data-brand-clear-all]',
    faq: '[data-faq]',
    faqSearch: '[data-faq-search]',
    faqSearchClear: '[data-faq-search-clear]',
    faqStatus: '[data-faq-status]',
    faqItem: '[data-faq-item]',
    faqGroup: '[data-faq-group]',
    faqCategory: '[data-faq-category]',
    faqEmpty: '[data-faq-empty]',
    cartCount: '[data-cart-count]',
    mobileNav: '[data-mobile-nav]',
    cartLiveRegion: '[data-cart-live]',
    cartSheetSource: '[data-cart-drawer-body]',
    cartSheetFooter: '[data-cart-drawer-footer]',
    policyToc: '[data-policy-toc]',
    policyTocList: '[data-policy-toc-list]',
    policyBody: '.policy-content__body',
    condenseHeader: '[data-condense-header]',
    megaTrigger: '[data-mega-trigger]',
    megaPanel: '[data-mega-panel]',
    megaItem: '[data-mega-item]',
    siteHeader: '[data-y10-header]',
    announcementBar: '[data-announcement-bar]',
    announcementItem: '[data-announcement-item]',
    mobileAccordionToggle: '[data-mobile-accordion-toggle]',
    localeRoot: '[data-y10-locale]',
    localeToggle: '[data-y10-locale-toggle]',
    localePanel: '[data-y10-locale-panel]',
    productPrice: '[data-product-price]',
    productAvailability: '[data-product-availability]',
    productSku: '[data-product-sku]',
    stickyAtcPrice: '[data-sticky-atc-price]',
    stickyAtcText: '[data-sticky-atc-text]',
    optionPosition: '[data-option-position]',
    optionValue: '[data-option-value]',
    optionAvailabilityNote: '[data-option-availability-note]',
    dynamicCheckout: '[data-dynamic-checkout]',
    inBag: '[data-in-bag]',
    inBagCount: '[data-in-bag-count]',
    viewBag: '[data-view-bag]',
    stickyQuantityValue: '[data-sticky-quantity-value]',
    stickyQuantityMinus: '[data-sticky-quantity-minus]',
    stickyQuantityPlus: '[data-sticky-quantity-plus]',
    cartDrawerLine: '[data-cart-line]',
    cartLineIncrease: '[data-cart-line-increase]',
    cartLineDecrease: '[data-cart-line-decrease]',
    cartLineRemove: '[data-cart-line-remove]',
    cartLineQuantity: '[data-cart-line-quantity]'
  };

  /* How long the ADDED TO BAG confirmation holds before the purchase area
     hands over to the compact cart-aware row. */
  var ADDED_STATE_MS = 1600;

  var RECENT_SEARCH_KEY = 'y10_recent_searches';

  /* ---- Money formatting -------------------------------------------------- */

  function formatMoney(cents, format) {
    if (cents == null) return '';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollars + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, dollars)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, dollars + '.' + parts[1]);
  }

  function readRecentSearches() {
    try {
      return JSON.parse(window.localStorage.getItem(RECENT_SEARCH_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeRecentSearches(list) {
    try {
      window.localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (error) {
      /* storage unavailable */
    }
  }

  /* ---- Cart state -----------------------------------------------------------
     One source of truth. Every purchase surface reads from here and re-renders
     on y10:cart:updated rather than keeping its own counter.
  --------------------------------------------------------------------------- */

  var CartStore = {
    data: null,
    inFlight: null,

    publish: function (cart) {
      if (!cart || typeof cart.item_count !== 'number') return cart;
      this.data = cart;
      document.dispatchEvent(new CustomEvent('y10:cart:updated', { detail: { cart: cart } }));
      return cart;
    },

    load: function (force) {
      if (!window.Y10 || !window.Y10.routes || !window.Y10.routes.cart) return Promise.resolve(null);
      if (!force && this.data) return Promise.resolve(this.data);
      if (this.inFlight) return this.inFlight;

      var self = this;
      this.inFlight = fetch(window.Y10.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          return self.publish(cart);
        })
        .catch(function () {
          return null;
        })
        .then(function (cart) {
          self.inFlight = null;
          return cart;
        });

      return this.inFlight;
    },

    /* Change by line key. Shopify returns the whole cart, so no second read.
       A rejected change (for example asking for more than the stock on hand)
       comes back 422 and must be surfaced, not swallowed. */
    change: function (lineKey, quantity) {
      if (!window.Y10 || !window.Y10.routes.cartChange) return Promise.resolve(null);
      var self = this;
      return fetch(window.Y10.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              var error = new Error(data.description || data.message || window.Y10.strings.cartError);
              error.cartRejected = true;
              throw error;
            }
            return data;
          });
        })
        .then(function (cart) {
          return self.publish(cart);
        })
        .catch(function (error) {
          if (error && error.cartRejected) {
            showCartToast(error.message);
            announceCart(error.message);
          }
          /* Re-read so every surface reflects what the cart actually holds. */
          return self.load(true).then(function () {
            throw error;
          });
        });
    },

    lineFor: function (variantId) {
      if (!this.data || !this.data.items) return null;
      var id = Number(variantId);
      for (var i = 0; i < this.data.items.length; i += 1) {
        if (Number(this.data.items[i].id) === id) return this.data.items[i];
      }
      return null;
    },

    quantityFor: function (variantId) {
      var line = this.lineFor(variantId);
      return line ? line.quantity : 0;
    }
  };

  window.Y10 = window.Y10 || {};
  window.Y10.cart = CartStore;

  function renderCartCounts(cart) {
    if (!cart) return;
    document.querySelectorAll(selectors.cartCount).forEach(function (counter) {
      counter.textContent = String(cart.item_count);
      counter.hidden = cart.item_count === 0;
    });
  }

  document.addEventListener('y10:cart:updated', function (event) {
    renderCartCounts(event.detail.cart);
  });

  function refreshCartCount() {
    return CartStore.load(true);
  }

  function lockScroll(locked) {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
  }

  function getOverlay() {
    return document.querySelector(selectors.drawerOverlay);
  }

  var panelFocusables = 'button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  var openPanelElement = null;
  var panelReturnFocus = null;

  function getPanelFocusables(panel) {
    return Array.prototype.filter.call(panel.querySelectorAll(panelFocusables), function (element) {
      return !element.disabled && element.offsetParent !== null;
    });
  }

  function openPanel(panel) {
    if (!panel) return;
    panelReturnFocus = document.activeElement;
    openPanelElement = panel;
    panel.setAttribute('open', '');
    panel.setAttribute('aria-hidden', 'false');
    var overlay = getOverlay();
    if (overlay) overlay.setAttribute('open', '');
    lockScroll(true);
    var focusTarget = getPanelFocusables(panel)[0];
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closePanels() {
    document.querySelectorAll(selectors.drawer + ', ' + selectors.cartDrawer + ', ' + selectors.collectionFilterDrawer + ', ' + selectors.searchSheet).forEach(function (panel) {
      panel.removeAttribute('open');
      panel.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[aria-expanded="true"]' + selectors.drawerOpen + ', [aria-expanded="true"]' + selectors.collectionFilterOpen + ', [aria-expanded="true"]' + selectors.searchSheetOpen).forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    var overlay = getOverlay();
    if (overlay) overlay.removeAttribute('open');
    lockScroll(false);
    openPanelElement = null;
    if (panelReturnFocus && document.contains(panelReturnFocus)) {
      panelReturnFocus.focus({ preventScroll: true });
    }
    panelReturnFocus = null;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !openPanelElement) return;
    var focusables = getPanelFocusables(openPanelElement);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (!openPanelElement.contains(document.activeElement)) {
      event.preventDefault();
      first.focus({ preventScroll: true });
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  });

  document.addEventListener('click', function (event) {
    var drawerTrigger = event.target.closest(selectors.drawerOpen);
    if (drawerTrigger) {
      /* One button, two behaviours by width: the catalogue opens the drawer on
         a phone and its own mega panel on desktop. Without this guard the
         desktop click would slide the phone sheet over the panel it just
         opened. */
      if (drawerTrigger.hasAttribute('data-drawer-mobile-only') && window.innerWidth >= 990) return;
      var drawer = document.getElementById(drawerTrigger.getAttribute('data-drawer-open'));
      drawerTrigger.setAttribute('aria-expanded', 'true');
      openPanel(drawer);
      return;
    }

    var cartTrigger = event.target.closest(selectors.cartDrawerOpen);
    if (cartTrigger && document.querySelector(selectors.cartDrawer)) {
      event.preventDefault();
      openPanel(document.querySelector(selectors.cartDrawer));
      return;
    }

    if (
      event.target.closest(selectors.drawerClose) ||
      event.target.closest(selectors.cartDrawerClose) ||
      event.target.closest(selectors.collectionFilterClose) ||
      event.target.closest(selectors.searchSheetClose) ||
      event.target.matches(selectors.drawerOverlay)
    ) {
      closePanels();
    }
  });

  function setGalleryMedia(gallery, mediaId) {
    gallery.querySelectorAll(selectors.productGallerySlide).forEach(function (slide) {
      var isActive = slide.getAttribute('data-media-id') === mediaId;
      slide.classList.toggle('is-active', isActive);
      if (isActive) slide.removeAttribute('hidden');
      else slide.setAttribute('hidden', '');
    });

    gallery.querySelectorAll(selectors.productGalleryThumb).forEach(function (thumb) {
      var isActive = thumb.getAttribute('data-media-id') === mediaId;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', String(isActive));
      
      if (isActive) {
        thumb.removeAttribute('tabindex');
      } else {
        thumb.setAttribute('tabindex', '-1');
      }
    });
  }

  function getGalleryMediaIds(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll(selectors.productGallerySlide)).map(function (slide) {
      return slide.getAttribute('data-media-id');
    });
  }

  function stepGallery(gallery, direction) {
    var mediaIds = getGalleryMediaIds(gallery);
    if (mediaIds.length < 2) return;
    var active = gallery.querySelector(selectors.productGallerySlide + '.is-active');
    var currentId = active ? active.getAttribute('data-media-id') : mediaIds[0];
    var currentIndex = mediaIds.indexOf(currentId);
    var nextIndex = (currentIndex + direction + mediaIds.length) % mediaIds.length;
    setGalleryMedia(gallery, mediaIds[nextIndex]);
  }

  document.querySelectorAll(selectors.productGallery).forEach(function (gallery) {
    var touchStartX = 0;

    gallery.querySelectorAll(selectors.productGalleryThumb).forEach(function (thumb) {
      if (thumb.getAttribute('aria-selected') !== 'true') {
        thumb.setAttribute('tabindex', '-1');
      }
    });

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest(selectors.productGalleryThumb);
      if (thumb) {
        setGalleryMedia(gallery, thumb.getAttribute('data-media-id'));
        thumb.focus();
        return;
      }

      var zoom = event.target.closest(selectors.productGalleryZoom);
      if (!zoom || gallery.getAttribute('data-enable-fullscreen') !== 'true') return;

      var activeImage = gallery.querySelector(selectors.productGallerySlide + '.is-active img');
      if (!activeImage) return;

      var returnFocus = document.activeElement;
      var lightbox = document.createElement('div');
      lightbox.className = 'product-gallery-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', activeImage.alt || '');
      lightbox.innerHTML =
        '<button class="product-gallery-lightbox__close icon-button" type="button" aria-label="' +
        (window.Y10 && window.Y10.strings ? window.Y10.strings.close : 'Close') +
        '">×</button><img src="' +
        activeImage.currentSrc +
        '" alt="' +
        activeImage.alt.replace(/"/g, '&quot;') +
        '">';
      document.body.appendChild(lightbox);
      lockScroll(true);

      var closeButton = lightbox.querySelector('button');
      closeButton.focus();

      function closeLightbox() {
        document.removeEventListener('keydown', onLightboxKey, true);
        lightbox.remove();
        lockScroll(false);
        if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
      }

      /* Only one focusable control, so the trap is simply keeping focus on it. */
      function onLightboxKey(keyEvent) {
        if (keyEvent.key === 'Escape') {
          keyEvent.preventDefault();
          closeLightbox();
        } else if (keyEvent.key === 'Tab') {
          keyEvent.preventDefault();
          closeButton.focus();
        }
      }

      document.addEventListener('keydown', onLightboxKey, true);

      lightbox.addEventListener('click', function (lightboxEvent) {
        if (lightboxEvent.target === lightbox || lightboxEvent.target.closest('button')) {
          closeLightbox();
        }
      });
    });

    gallery.addEventListener('keydown', function (event) {
      var thumb = event.target.closest(selectors.productGalleryThumb);
      if (!thumb) return;

      var isRightOrDown = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      var isLeftOrUp = event.key === 'ArrowLeft' || event.key === 'ArrowUp';

      if (isRightOrDown || isLeftOrUp) {
        event.preventDefault();
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(selectors.productGalleryThumb));
        var currentIndex = thumbs.indexOf(thumb);
        var direction = isRightOrDown ? 1 : -1;
        var nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
        
        var nextThumb = thumbs[nextIndex];
        setGalleryMedia(gallery, nextThumb.getAttribute('data-media-id'));
        nextThumb.focus();
      }
    });


    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) stepGallery(gallery, deltaX > 0 ? -1 : 1);
    }, { passive: true });
  });

  document.querySelectorAll(selectors.mainProduct).forEach(function (section) {
    var variantJson = section.querySelector(selectors.productVariantState);
    var variants = [];
    if (variantJson) {
      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        variants = [];
      }
    }

    var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';
    var lowStockThreshold = parseInt(section.getAttribute('data-low-stock-threshold'), 10) || 5;
    var atcLabel = section.getAttribute('data-atc-label') || 'Add to Cart';
    var soldOutLabel = section.getAttribute('data-sold-out-label') || 'Sold Out';
    var inStockLabel = section.getAttribute('data-in-stock-label') || 'In Stock';
    var outOfStockLabel = section.getAttribute('data-out-of-stock-label') || 'Out of Stock';
    var lowStockLabel = section.getAttribute('data-low-stock-label') || 'Low stock — only [count] left';
    var preOrderLabel = section.getAttribute('data-pre-order-label') || 'Pre-order';
    var skuLabel = section.getAttribute('data-sku-label') || 'SKU';
    var unavailableLabel = section.getAttribute('data-unavailable-label') || 'Unavailable';
    var regularPriceLabel = section.getAttribute('data-regular-price-label') || 'Regular price';
    var comparePriceLabel = section.getAttribute('data-compare-price-label') || 'Compare at price';
    var unavailableComboLabel = section.getAttribute('data-unavailable-combination-label') || 'This combination is unavailable';
    var optionUnavailableLabel = section.getAttribute('data-option-unavailable-label') || '[value] — unavailable';
    var productTitle = section.getAttribute('data-product-title') || '';
    var savePercentLabel = section.getAttribute('data-save-percent-label') || 'Save [percent]%';
    var eachLabel = section.getAttribute('data-each-label') || '[amount] each';

    /* One quantity state per purchase form; the price displays derive from it. */
    var activeVariant = null;

    function fill(template, token, value) {
      return template.replace('[' + token + ']', value).replace('{{ ' + token + ' }}', value);
    }

    function getSelectedOptions() {
      return Array.prototype.slice.call(section.querySelectorAll(selectors.optionValue + ':checked')).map(function (input) {
        return input.value;
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selected[index];
        });
      });
    }

    /* ---- Price rendering ------------------------------------------------ */

    /* Renders the purchase total for `quantity` units. The unit price is never
       mutated — quantity only scales what is displayed, and the discount
       percentage stays derived from unit pricing. */
    function renderPrice(container, variant, quantity) {
      if (!container) return;

      var units = quantity && quantity > 0 ? quantity : 1;
      var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var total = variant.price * units;

      var priceHtml = '<div class="price' +
        (isOnSale ? ' price--on-sale' : '') +
        (!variant.available ? ' price--sold-out' : '') +
        '">' +
        '<span class="visually-hidden">' + regularPriceLabel + '</span>' +
        '<span class="price__regular">' + formatMoney(total, moneyFormat) + '</span>';

      if (isOnSale) {
        var discountPercent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        priceHtml +=
          '<span class="visually-hidden">' + comparePriceLabel + '</span>' +
          '<s class="price__compare">' + formatMoney(variant.compare_at_price * units, moneyFormat) + '</s>' +
          '<span class="price__discount">' + fill(savePercentLabel, 'percent', discountPercent) + '</span>';
      }

      /* Above one unit, say what a single unit costs so the total is readable. */
      if (units > 1) {
        priceHtml += '<span class="price__unit">' +
          fill(eachLabel, 'amount', formatMoney(variant.price, moneyFormat)) +
          '</span>';
      }

      priceHtml += '</div>';
      container.innerHTML = priceHtml;
    }

    /* ---- Availability rendering ----------------------------------------- */

    function renderAvailability(container, variant) {
      if (!container) return;
      var tracksInventory = variant.inventory_management != null && variant.inventory_management !== '';
      var qty = variant.inventory_quantity || 0;
      var html = '';

      if (!variant.available) {
        html = '<div class="availability availability--error">' +
          '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4"></path><path d="M12 17h.01"></path><path d="m10.3 3.9-8.1 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3.1l-8-14a2 2 0 0 0-3.4 0Z"></path></svg>' +
          '<span>' + outOfStockLabel + '</span></div>';
      } else if (tracksInventory && qty > 0 && qty <= lowStockThreshold) {
        html = '<div class="availability availability--warning">' +
          '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4"></path><path d="M12 17h.01"></path><path d="m10.3 3.9-8.1 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3.1l-8-14a2 2 0 0 0-3.4 0Z"></path></svg>' +
          '<span>' + lowStockLabel.replace('[count]', qty).replace('{{ count }}', qty) + '</span></div>';
      } else if (variant.inventory_policy === 'continue' && qty <= 0) {
        html = '<div class="availability">' +
          '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"></path></svg>' +
          '<span>' + preOrderLabel + '</span></div>';
      } else {
        html = '<div class="availability">' +
          '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"></path></svg>' +
          '<span>' + inStockLabel + '</span></div>';
      }

      container.innerHTML = html;
    }

    /* ---- Swatch availability -------------------------------------------- */

    function updateSwatchAvailability() {
      var selected = getSelectedOptions();
      var fieldsets = Array.prototype.slice.call(section.querySelectorAll(selectors.optionPosition));

      fieldsets.forEach(function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-position'), 10) - 1;
        var inputs = Array.prototype.slice.call(fieldset.querySelectorAll(selectors.optionValue));

        inputs.forEach(function (input) {
          var testOptions = selected.slice();
          testOptions[position] = input.value;

          var hasAvailable = variants.some(function (v) {
            return v.options[position] === input.value && v.options.every(function (opt, idx) {
              return idx === position || opt === testOptions[idx];
            }) && v.available;
          });

          var label = input.nextElementSibling || fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) {
            label.classList.toggle('option-swatches__label--unavailable', !hasAvailable);

            /* The option stays selectable — choosing it is how a customer
               discovers the combination is gone — so the state is announced in
               the accessible name instead of being disabled. */
            var note = label.querySelector(selectors.optionAvailabilityNote);
            if (note) {
              note.textContent = hasAvailable ? '' : ' (' + optionUnavailableLabel + ')';
            }
          }
          input.dataset.optionAvailable = hasAvailable ? 'true' : 'false';
        });
      });
    }

    /* ---- Unavailable combination ---------------------------------------- */

    function syncUnavailableCombination() {
      var error = section.querySelector(selectors.productFormError);

      section.querySelectorAll(selectors.productPrice).forEach(function (node) {
        node.hidden = true;
      });
      var availability = section.querySelector(selectors.productAvailability);
      if (availability) availability.hidden = true;
      var sku = section.querySelector(selectors.productSku);
      if (sku) sku.hidden = true;

      section.querySelectorAll(selectors.addToCart).forEach(function (button) {
        button.disabled = true;
        button.dataset.restingLabel = unavailableLabel;
        var text = button.querySelector(selectors.addToCartText);
        if (text) text.textContent = unavailableLabel;
      });

      var stickyBtn = section.querySelector(selectors.stickyAtcButton);
      if (stickyBtn) {
        stickyBtn.disabled = true;
        var stickyText = stickyBtn.querySelector(selectors.stickyAtcText);
        if (stickyText) stickyText.textContent = unavailableLabel;
      }

      var dynamic = section.querySelector(selectors.dynamicCheckout);
      if (dynamic) dynamic.hidden = true;

      var inBagNote = section.querySelector(selectors.inBag);
      if (inBagNote) inBagNote.hidden = true;

      if (error) {
        error.textContent = unavailableComboLabel;
        error.hidden = false;
      }

      updateSwatchAvailability();
    }

    /* ---- Full variant sync ---------------------------------------------- */

    function syncVariant(variant) {
      var error = section.querySelector(selectors.productFormError);
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      /* Variant ID */
      section.querySelectorAll(selectors.productVariantId).forEach(function (input) {
        input.value = variant.id;
      });

      /* SKU */
      var sku = section.querySelector(selectors.productSku);
      if (sku) {
        if (variant.sku) {
          sku.textContent = skuLabel + ' ' + variant.sku;
          sku.hidden = false;
        } else {
          sku.hidden = true;
        }
      }

      activeVariant = variant;

      /* Price */
      var priceNode = section.querySelector(selectors.productPrice);
      renderPrice(priceNode, variant, readQuantity());
      if (priceNode) priceNode.hidden = false;

      /* Availability */
      var availabilityNode = section.querySelector(selectors.productAvailability);
      renderAvailability(availabilityNode, variant);
      if (availabilityNode) availabilityNode.hidden = false;

      /* ATC button */
      section.querySelectorAll(selectors.addToCart).forEach(function (button) {
        button.disabled = !variant.available;
        var label = variant.available ? atcLabel : soldOutLabel;
        button.dataset.restingLabel = label;
        var text = button.querySelector(selectors.addToCartText);
        if (text) text.textContent = label;
      });

      /* Gallery */
      if (variant.featured_media_id) {
        var gallery = section.querySelector(selectors.productGallery);
        if (gallery) setGalleryMedia(gallery, String(variant.featured_media_id));
      }

      /* Sticky ATC */
      var sticky = section.querySelector(selectors.stickyAtc);
      if (sticky) {
        renderPrice(sticky.querySelector(selectors.stickyAtcPrice), variant, readQuantity());
        var stickyBtn = sticky.querySelector(selectors.stickyAtcButton);
        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          var stickyText = stickyBtn.querySelector(selectors.stickyAtcText);
          if (stickyText) stickyText.textContent = variant.available ? atcLabel : soldOutLabel;
        }
      }

      /* Dynamic checkout is meaningless for a variant that cannot be bought. */
      var dynamic = section.querySelector(selectors.dynamicCheckout);
      if (dynamic) dynamic.hidden = !variant.available;

      /* URL */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      /* Swatch availability */
      updateSwatchAvailability();

      /* Cart awareness is informational and variant-specific. */
      renderInBag();
    }

    /* ---- Cart awareness (informational) ---------------------------------
       The purchase CTA is never replaced. This only reports what the cart
       already holds for the selected variant; editing happens in the drawer.
    --------------------------------------------------------------------- */

    var inBagNotes = Array.prototype.slice.call(section.querySelectorAll(selectors.inBag));
    var inBagNoteLabel = section.getAttribute('data-in-bag-note-label') || '[count] already in your bag';

    function currentVariantId() {
      var input = section.querySelector(selectors.productVariantId);
      return input ? input.value : null;
    }

    function renderInBag() {
      if (!inBagNotes.length) return;

      var variantId = currentVariantId();
      var quantity = CartStore.data && variantId ? CartStore.quantityFor(variantId) : 0;

      inBagNotes.forEach(function (note) {
        var count = note.querySelector(selectors.inBagCount);
        if (count) count.textContent = fill(inBagNoteLabel, 'count', quantity);
        note.hidden = quantity < 1;
      });
    }

    document.addEventListener('y10:cart:updated', renderInBag);

    /* View bag prefers the drawer that is already on the page. */
    section.addEventListener('click', function (event) {
      if (!event.target.closest(selectors.viewBag)) return;
      var drawer = document.querySelector(selectors.cartDrawer);
      if (drawer) {
        openPanel(drawer);
        return;
      }
      window.location.href = (window.Y10 && window.Y10.routes.cart) || '/cart';
    });

    /* ---- Sticky quantity proxy -------------------------------------------
       Mirrors the form's quantity input in both directions so there is still
       only one quantity value, the one the form submits.
    --------------------------------------------------------------------- */

    var quantityInput = section.querySelector('[data-purchase-quantity] [data-quantity-input]');
    var stickyQuantityValue = section.querySelector(selectors.stickyQuantityValue);

    function readQuantity() {
      if (!quantityInput) return 1;
      var min = parseInt(quantityInput.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var value = parseInt(quantityInput.value, 10);
      if (isNaN(value) || value < min) value = min;
      return value;
    }

    function writeQuantity(value) {
      if (!quantityInput) return;
      quantityInput.value = String(value);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function variantById(id) {
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* Re-render every quantity-dependent price for the current selection.
       Display only — no cart request is made for a pre-add quantity change. */
    function renderPurchasePrices() {
      if (!activeVariant) return;
      var units = readQuantity();
      renderPrice(section.querySelector(selectors.productPrice), activeVariant, units);
      var stickyPrice = section.querySelector(selectors.stickyAtcPrice);
      if (stickyPrice) renderPrice(stickyPrice, activeVariant, units);
    }

    function renderStickyQuantity() {
      if (stickyQuantityValue) stickyQuantityValue.textContent = String(readQuantity());
    }

    function syncQuantitySurfaces() {
      renderStickyQuantity();
      renderPurchasePrices();
    }

    if (quantityInput) {
      /* Guard the field itself against 0, negatives and non-numeric input. */
      quantityInput.addEventListener('change', function () {
        var clamped = readQuantity();
        if (quantityInput.value !== String(clamped)) quantityInput.value = String(clamped);
        syncQuantitySurfaces();
      });
      quantityInput.addEventListener('input', syncQuantitySurfaces);
    }

    section.addEventListener('click', function (event) {
      var down = event.target.closest(selectors.stickyQuantityMinus);
      var up = event.target.closest(selectors.stickyQuantityPlus);
      if (!down && !up) return;

      var min = quantityInput ? parseInt(quantityInput.getAttribute('min'), 10) || 1 : 1;
      var next = up ? readQuantity() + 1 : Math.max(min, readQuantity() - 1);
      /* writeQuantity fires a change event, which drives the shared sync. */
      writeQuantity(next);
    });

    /* Seed the active variant from what the server rendered. */
    var variantIdInput = section.querySelector(selectors.productVariantId);
    activeVariant = variantIdInput ? variantById(variantIdInput.value) : null;
    if (!activeVariant && variants.length) activeVariant = variants[0];

    syncQuantitySurfaces();

    /* ---- Option change listener ----------------------------------------- */

    section.addEventListener('change', function (event) {
      if (!event.target.matches(selectors.optionValue)) return;

      var fieldset = event.target.closest(selectors.optionPosition);
      if (fieldset) {
        var selectedName = fieldset.querySelector(selectors.selectedOptionName);
        if (selectedName) selectedName.textContent = event.target.value;
      }

      var variant = findVariant();

      /* No matching variant means the chosen combination does not exist. The
         previous variant's price and availability must not stay on screen. */
      if (!variant) {
        syncUnavailableCombination();
        return;
      }

      syncVariant(variant);
    });

    /* Initialize swatch availability on page load */
    if (variants.length > 0) {
      updateSwatchAvailability();
    }

    CartStore.load().then(renderInBag);

    /* ---- Sticky ATC visibility ----------------------------------------- */

    var sticky = section.querySelector(selectors.stickyAtc);
    var formButton = section.querySelector(selectors.addToCart);
    /* Observe the purchase block, not the add button: the button is hidden
       while the variant is in the bag, and a hidden target never intersects. */
    var stickyAnchor = section.querySelector('.product-page__buttons') || formButton;
    if (sticky && formButton && stickyAnchor) {
      var setStickyVisible = function (visible) {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', visible);
      };

      /* The bar is mobile-only, so its observer and scroll work are torn down
         on desktop rather than running against a hidden element. */
      var stickyMedia = window.matchMedia('(max-width: 989px)');
      var stickyObserver = null;
      var stickyScrollHandler = null;

      var enableSticky = function () {
        if (stickyObserver || stickyScrollHandler) return;

        if ('IntersectionObserver' in window) {
          /* "Off screen" is not enough: at the top of the page the purchase
             block is simply below the fold and has not been reached yet. The
             bar is only for the state where it has been scrolled past, so the
             block's position relative to the viewport decides. */
          stickyObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              setStickyVisible(scrolledPast);
            });
          }, { threshold: 0 });
          stickyObserver.observe(stickyAnchor);
        } else {
          stickyScrollHandler = function () {
            var rect = stickyAnchor.getBoundingClientRect();
            setStickyVisible(rect.bottom < 0);
          };
          window.addEventListener('scroll', stickyScrollHandler, { passive: true });
          stickyScrollHandler();
        }
      };

      var disableSticky = function () {
        if (stickyObserver) {
          stickyObserver.disconnect();
          stickyObserver = null;
        }
        if (stickyScrollHandler) {
          window.removeEventListener('scroll', stickyScrollHandler);
          stickyScrollHandler = null;
        }
        setStickyVisible(false);
      };

      var syncStickyMode = function () {
        if (stickyMedia.matches) enableSticky();
        else disableSticky();
      };

      syncStickyMode();

      if (stickyMedia.addEventListener) stickyMedia.addEventListener('change', syncStickyMode);
      else if (stickyMedia.addListener) stickyMedia.addListener(syncStickyMode);

      var stickyButton = sticky.querySelector(selectors.stickyAtcButton);
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          formButton.click();
        });
      }
    }
  });

  /* ---- Product details: desktop tabs, mobile accordions ---------------------
     One set of triggers and one set of panels serve both presentations. At
     desktop the triggers are moved into a real tablist rather than having tab
     roles approximated in place; below that they return to their accordion
     position in front of the panel they control.
  ------------------------------------------------------------------------- */

  function setupProductDetails(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll(selectors.detailsTrigger));
    if (!triggers.length) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var nav = null;
    var mode = null;

    function panelFor(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    /* Whatever Liquid rendered open is what the interactive version starts on. */
    function openIndex() {
      for (var i = 0; i < triggers.length; i += 1) {
        if (triggers[i].getAttribute('aria-expanded') === 'true') return i;
      }
      return 0;
    }

    function selectTab(index, moveFocus) {
      triggers.forEach(function (trigger, i) {
        var isActive = i === index;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        trigger.tabIndex = isActive ? 0 : -1;
        var panel = panelFor(trigger);
        if (panel) panel.hidden = !isActive;
      });
      if (moveFocus && triggers[index]) triggers[index].focus();
    }

    /* Accordions are independent: opening one never closes another. */
    function toggleAccordion(trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    }

    function applyTabs() {
      if (!nav) {
        nav = document.createElement('div');
        nav.className = 'product-details__nav';
        nav.setAttribute('role', 'tablist');
        var navLabel = root.getAttribute('data-details-label');
        if (navLabel) nav.setAttribute('aria-label', navLabel);
      }

      root.insertBefore(nav, root.firstChild);

      triggers.forEach(function (trigger) {
        nav.appendChild(trigger);
        trigger.setAttribute('role', 'tab');
        var panel = panelFor(trigger);
        if (panel) {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
        }
      });

      selectTab(openIndex(), false);
    }

    function applyAccordions() {
      triggers.forEach(function (trigger) {
        trigger.removeAttribute('role');
        trigger.removeAttribute('aria-selected');
        trigger.removeAttribute('tabindex');
        var panel = panelFor(trigger);
        if (!panel) return;
        panel.removeAttribute('role');
        panel.removeAttribute('tabindex');
        root.insertBefore(trigger, panel);
      });

      if (nav && nav.parentNode) nav.parentNode.removeChild(nav);
    }

    function applyMode() {
      var next = desktop.matches ? 'tabs' : 'accordions';
      if (next === mode) return;

      /* Moving a focused trigger between containers drops focus, so restore it. */
      var focused = triggers.indexOf(document.activeElement) > -1 ? document.activeElement : null;
      mode = next;

      if (next === 'tabs') {
        applyTabs();
      } else {
        applyAccordions();
      }

      if (focused) focused.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest(selectors.detailsTrigger);
      if (!trigger || triggers.indexOf(trigger) === -1) return;

      if (mode === 'tabs') {
        selectTab(triggers.indexOf(trigger), false);
      } else {
        toggleAccordion(trigger);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (mode !== 'tabs') return;
      var trigger = event.target.closest(selectors.detailsTrigger);
      if (!trigger) return;

      var index = triggers.indexOf(trigger);
      if (index === -1) return;

      var next = index;
      if (event.key === 'ArrowRight') {
        next = (index + 1) % triggers.length;
      } else if (event.key === 'ArrowLeft') {
        next = (index - 1 + triggers.length) % triggers.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = triggers.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      selectTab(next, true);
    });

    applyMode();

    if (desktop.addEventListener) {
      desktop.addEventListener('change', applyMode);
    } else if (desktop.addListener) {
      desktop.addListener(applyMode);
    }
  }

  document.querySelectorAll(selectors.productDetails).forEach(setupProductDetails);

  document.addEventListener('click', function (event) {
    var share = event.target.closest(selectors.shareButton);
    if (!share) return;

    var shareUrl = share.getAttribute('data-share-url') || window.location.href;
    var shareScope = share.closest('.share-buttons');
    var shareStatus = shareScope ? shareScope.querySelector('[data-share-status]') : null;

    if (navigator.share) {
      navigator.share({ url: shareUrl }).catch(function () {});
      return;
    }

    if (!navigator.clipboard) return;

    navigator.clipboard
      .writeText(shareUrl)
      .then(function () {
        if (shareStatus) shareStatus.textContent = (window.Y10.strings || {}).shareCopied || '';
      })
      .catch(function () {
        if (shareStatus) shareStatus.textContent = (window.Y10.strings || {}).shareCopyFailed || '';
      });
  });

  document.querySelectorAll(selectors.productRecommendations).forEach(function (section) {
    var url = section.getAttribute('data-url');

    /* data-loading is only present on the skeleton shell Liquid renders when
       recommendations have not been performed. A server-rendered result has no
       such marker, so an already-populated section is never re-fetched. */
    if (!url || section.getAttribute('data-loading') !== 'true') return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionClass = section.className.match(/section-[^\s]+/);
        var next = sectionClass ? doc.querySelector(selectors.productRecommendations + '.' + sectionClass[0]) : null;
        if (!next) next = doc.querySelector(selectors.productRecommendations);

        var markup = next ? next.innerHTML.trim() : '';
        section.removeAttribute('data-loading');

        if (markup) {
          section.innerHTML = markup;
          /* The response carries column/track custom properties sized to the
             products actually returned, so adopt them with the markup. */
          var nextStyle = next.getAttribute('style');
          if (nextStyle) section.setAttribute('style', nextStyle);
          updateWishlistButtons(section);
        } else {
          /* Empty response: remove the shell entirely rather than leave a
             heading with nothing under it. */
          section.innerHTML = '';
          section.hidden = true;
        }
      })
      .catch(function () {
        section.removeAttribute('data-loading');
        section.innerHTML = '';
        section.hidden = true;
      });
  });

  document.querySelectorAll(selectors.recentlyViewed).forEach(function (section) {
    var currentHandle = section.getAttribute('data-current-product');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var key = 'y10_recently_viewed';
    var handles = [];

    try {
      handles = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      handles = [];
    }

    var displayHandles = handles.filter(function (handle) {
      return handle && handle !== currentHandle;
    }).slice(0, limit);

    handles = [currentHandle].concat(displayHandles).filter(Boolean);
    window.localStorage.setItem(key, JSON.stringify(handles.slice(0, 12)));

    var grid = section.querySelector(selectors.recentlyViewedGrid);
    if (!grid) return;

    /* Nothing to show: drop the whole section so no heading-only shell remains. */
    if (!displayHandles.length) {
      section.hidden = true;
      return;
    }

    grid.hidden = false;

    Promise.all(displayHandles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-card')
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-recently-viewed-card]');
        })
        .catch(function () {
          return null;
        });
    })).then(function (cards) {
      var loaded = 0;
      grid.innerHTML = '';

      cards.forEach(function (card) {
        if (!card) return;
        grid.appendChild(card);
        loaded += 1;
      });

      if (!loaded) {
        section.hidden = true;
        return;
      }

      /* Cap the tracks to what actually rendered so two cards do not stretch
         across a four-column grid. */
      var configured = parseInt(section.style.getPropertyValue('--recently-viewed-columns-desktop'), 10) || loaded;
      if (loaded < configured) {
        section.style.setProperty('--recently-viewed-columns-desktop', String(loaded));
        section.style.setProperty('--recently-viewed-track', '300px');
      }
      var tabletCols = parseInt(section.style.getPropertyValue('--recently-viewed-columns-tablet'), 10) || loaded;
      if (loaded < tabletCols) {
        section.style.setProperty('--recently-viewed-columns-tablet', String(loaded));
      }

      updateWishlistButtons(grid);
    });
  });

  document.querySelectorAll(selectors.searchPage).forEach(function (section) {
    var query = (section.getAttribute('data-search-query') || '').trim();
    var key = 'y10_recent_searches';
    var searches = [];

    try {
      searches = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      searches = [];
    }

    if (query) {
      searches = searches.filter(function (term) {
        return term.toLowerCase() !== query.toLowerCase();
      });
      searches.unshift(query);
      searches = searches.slice(0, 8);
      window.localStorage.setItem(key, JSON.stringify(searches));
    }

    var recentSection = section.querySelector(selectors.recentSearchesSection);
    var recentList = section.querySelector(selectors.recentSearchesList);
    if (!recentSection || !recentList || !searches.length) return;

    function renderRecentSearches() {
      if (!searches.length) {
        recentSection.hidden = true;
        return;
      }

      recentList.innerHTML = searches.map(function (term) {
        return (
          '<span class="search-token search-token--recent"><a href="/search?q=' +
          encodeURIComponent(term) +
          '&type=product&options%5Bprefix%5D=last">' +
          term +
          '</a><button class="search-token__remove" type="button" data-recent-search-remove="' +
          term.replace(/"/g, '&quot;') +
          '" aria-label="Remove ' +
          term.replace(/"/g, '&quot;') +
          '">×</button></span>'
        );
      }).join('');
      recentSection.hidden = false;
    }

    renderRecentSearches();

    section.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-recent-search-remove]');
      if (remove) {
        var term = remove.getAttribute('data-recent-search-remove');
        searches = searches.filter(function (item) {
          return item !== term;
        });
        window.localStorage.setItem(key, JSON.stringify(searches));
        renderRecentSearches();
        return;
      }

      if (event.target.closest(selectors.recentSearchesClear)) {
        searches = [];
        window.localStorage.removeItem(key);
        renderRecentSearches();
      }
    });
  });

  document.querySelectorAll(selectors.brandsDirectory).forEach(function (directory) {
    var cards = Array.prototype.slice.call(directory.querySelectorAll(selectors.brandCard));
    var searchInput = directory.querySelector(selectors.brandSearchInput);
    var status = directory.querySelector(selectors.brandStatus);
    var empty = directory.querySelector(selectors.brandsEmpty);
    var state = {
      query: '',
      letter: 'all',
      filter: 'All Brands'
    };

    function updateBrands() {
      var visible = 0;
      cards.forEach(function (card) {
        var title = (card.getAttribute('data-brand-title') || '').toLowerCase();
        var category = card.getAttribute('data-brand-category') || '';
        var letter = card.getAttribute('data-brand-letter') || '';
        var wrapper = card.closest('.brands-grid > div');
        var matchesQuery = !state.query || title.indexOf(state.query.toLowerCase()) !== -1;
        var matchesLetter = state.letter === 'all' || letter === state.letter;
        var matchesFilter = state.filter === 'All Brands' || category === state.filter;
        var isVisible = matchesQuery && matchesLetter && matchesFilter;
        if (wrapper) wrapper.hidden = !isVisible;
        if (isVisible) visible += 1;
      });

      if (status) {
        var template = status.getAttribute('data-brand-status-template') || '[count] brands';
        status.textContent = template.replace('[count]', visible);
      }
      if (empty) empty.hidden = visible !== 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.query = searchInput.value.trim();
        updateBrands();
      });
    }

    directory.addEventListener('click', function (event) {
      var clear = event.target.closest(selectors.brandSearchClear);
      if (clear && searchInput) {
        state.query = '';
        searchInput.value = '';
        updateBrands();
        searchInput.focus();
        return;
      }

      var letterButton = event.target.closest(selectors.brandLetter);
      if (letterButton) {
        state.letter = letterButton.getAttribute('data-brand-letter');
        directory.querySelectorAll(selectors.brandLetter).forEach(function (button) {
          button.classList.toggle('is-active', button === letterButton);
        });
        updateBrands();
        return;
      }

      var filterButton = event.target.closest(selectors.brandFilter);
      if (filterButton) {
        state.filter = filterButton.getAttribute('data-brand-filter');
        directory.querySelectorAll(selectors.brandFilter).forEach(function (button) {
          button.classList.toggle('is-active', button === filterButton);
        });
        updateBrands();
        return;
      }

      if (event.target.closest(selectors.brandClearAll)) {
        state.query = '';
        state.letter = 'all';
        state.filter = 'All Brands';
        if (searchInput) searchInput.value = '';
        directory.querySelectorAll(selectors.brandLetter).forEach(function (button) {
          button.classList.toggle('is-active', button.getAttribute('data-brand-letter') === 'all');
        });
        directory.querySelectorAll(selectors.brandFilter).forEach(function (button) {
          button.classList.toggle('is-active', button.getAttribute('data-brand-filter') === 'All Brands');
        });
        updateBrands();
      }
    });

    updateBrands();
  });


  document.addEventListener('click', function (event) {
    var recoverOpen = event.target.closest('[data-recover-open]');
    if (recoverOpen) {
      var auth = recoverOpen.closest('[data-account-auth]');
      if (!auth) return;
      var loginPanel = auth.querySelector('[data-login-panel]');
      var recoverPanel = auth.querySelector('[data-recover-panel]');
      if (loginPanel && recoverPanel) {
        loginPanel.hidden = true;
        recoverPanel.hidden = false;
        var input = recoverPanel.querySelector('input');
        if (input) input.focus();
      }
      return;
    }

    var recoverClose = event.target.closest('[data-recover-close]');
    if (recoverClose) {
      var closeAuth = recoverClose.closest('[data-account-auth]');
      if (!closeAuth) return;
      var closeLogin = closeAuth.querySelector('[data-login-panel]');
      var closeRecover = closeAuth.querySelector('[data-recover-panel]');
      if (closeLogin && closeRecover) {
        closeRecover.hidden = true;
        closeLogin.hidden = false;
      }
      return;
    }

    var addressToggle = event.target.closest('[data-address-toggle]');
    if (addressToggle) {
      var target = document.getElementById(addressToggle.getAttribute('data-address-toggle'));
      if (target) {
        target.hidden = !target.hidden;
        if (!target.hidden) {
          var focusTarget = target.querySelector('input, select, button');
          if (focusTarget) focusTarget.focus();
        }
      }
      return;
    }

    var deleteAddress = event.target.closest('[data-address-delete]');
    if (deleteAddress) {
      var message = deleteAddress.getAttribute('data-confirm-message') || 'Delete this address?';
      if (!window.confirm(message)) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = deleteAddress.getAttribute('data-target');
      form.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(form);
      form.submit();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePanels();
      document.querySelectorAll(selectors.predictiveResults).forEach(function (panel) {
        panel.removeAttribute('open');
        panel.innerHTML = '';
      });
    }
  });

  /* ---- Predictive search ---------------------------------------------------
     One implementation drives every search entry point. Everything rendered
     here comes from Shopify's predictive endpoint; nothing is invented, and a
     group with no results is not drawn at all.

     The panel is a real combobox: the input keeps focus and a virtual cursor
     moves through the options via aria-activedescendant, which is what the
     arrow keys actually do.
  ------------------------------------------------------------------------- */

  /* API strings are merchant-authored, so they are escaped before they are
     interpolated into markup. */
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Predictive search returns decimal strings in the shop currency; the shared
     money formatter works in cents. */
  function predictivePrice(value) {
    var amount = parseFloat(value);
    if (!isFinite(amount) || amount <= 0) return '';
    return formatMoney(Math.round(amount * 100), window.Y10.moneyFormat || '${{amount}}');
  }

  function fillString(template, token, value) {
    return String(template || '').replace(new RegExp('{{\\s*' + token + '\\s*}}', 'g'), value);
  }

  function predictiveOption(item, index, panelId) {
    var id = panelId + '-option-' + index;
    var media = item.image
      ? '<img class="predictive-search__image" src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="52" height="52">'
      : '<span class="predictive-search__image predictive-search__image--empty" aria-hidden="true"></span>';

    var meta = '';
    if (item.vendor) {
      meta += '<span class="predictive-search__vendor">' + escapeHtml(item.vendor) + '</span>';
    }

    var price = '';
    if (item.price) {
      price =
        '<span class="predictive-search__price">' + escapeHtml(item.price) +
        (item.compareAt ? '<s>' + escapeHtml(item.compareAt) + '</s>' : '') +
        '</span>';
    } else if (item.note) {
      price = '<span class="predictive-search__note">' + escapeHtml(item.note) + '</span>';
    }

    return (
      '<a class="predictive-search__option" role="option" id="' + id + '" aria-selected="false" href="' + escapeHtml(item.url) + '">' +
      media +
      '<span class="predictive-search__text">' +
      meta +
      '<span class="predictive-search__title">' + escapeHtml(item.title) + '</span>' +
      '</span>' + price + '</a>'
    );
  }

  function predictiveSkeleton() {
    var row =
      '<div class="predictive-search__skeleton">' +
      '<span class="ds-skeleton ds-skeleton--media"></span>' +
      '<span class="ds-skeleton ds-skeleton--text"></span>' +
      '</div>';
    return '<div class="predictive-search__inner" aria-hidden="true">' + row + row + row + '</div>';
  }

  function setupPredictiveSearch(wrapper) {
    var input = wrapper.querySelector(selectors.predictiveInput);
    var results = wrapper.querySelector(selectors.predictiveResults);
    var clear = wrapper.querySelector(selectors.searchClear);
    var form = wrapper.querySelector('form');
    var status = wrapper.querySelector('[data-predictive-search-status]');
    var popular = (wrapper.getAttribute('data-popular-searches') || '')
      .split(',')
      .map(function (term) { return term.trim(); })
      .filter(Boolean);

    if (!input || !results || !window.Y10 || !window.Y10.routes.predictiveSearch) return;

    var panelId = results.id || 'PredictiveResults';
    var controller;
    var debounce;
    var options = [];
    var activeIndex = -1;

    var strings = window.Y10.strings || {};
    var searchUrl = window.Y10.searchUrl || '/search';

    function announce(message) {
      if (status) status.textContent = message || '';
    }

    function setActive(index) {
      if (!options.length) return;
      if (activeIndex > -1 && options[activeIndex]) {
        options[activeIndex].setAttribute('aria-selected', 'false');
        options[activeIndex].classList.remove('is-active');
      }
      activeIndex = index;
      var option = options[activeIndex];
      if (!option) {
        input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      option.classList.add('is-active');
      input.setAttribute('aria-activedescendant', option.id);
      if (option.scrollIntoView) option.scrollIntoView({ block: 'nearest' });
    }

    function clearActive() {
      if (activeIndex > -1 && options[activeIndex]) {
        options[activeIndex].setAttribute('aria-selected', 'false');
        options[activeIndex].classList.remove('is-active');
      }
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function collectOptions() {
      options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function close() {
      results.removeAttribute('open');
      results.removeAttribute('role');
      input.setAttribute('aria-expanded', 'false');
      clearActive();
      options = [];
    }

    function open(isListbox) {
      results.setAttribute('open', '');
      /* The panel only claims to be a listbox when it actually holds options. */
      if (isListbox) results.setAttribute('role', 'listbox');
      else results.removeAttribute('role');
      input.setAttribute('aria-expanded', 'true');
    }

    /* ---- Discovery: recent and merchant-configured popular searches ------- */
    function showDiscovery() {
      var recent = readRecentSearches();
      var html = '';

      if (recent.length) {
        html +=
          '<div class="predictive-search__row"><p class="predictive-search__heading">' +
          escapeHtml(strings.searchRecent || 'Recent searches') +
          '</p><button class="predictive-search__clear" type="button" data-recent-clear>' +
          escapeHtml(strings.searchClearAll || 'Clear all') +
          '</button></div><ul class="predictive-search__chips">' +
          recent.map(function (term) {
            return '<li><a class="ds-chip ds-chip--compact" href="' + searchUrl + '?q=' +
              encodeURIComponent(term) + '">' + escapeHtml(term) + '</a></li>';
          }).join('') + '</ul>';
      }

      if (popular.length) {
        html +=
          '<p class="predictive-search__heading">' +
          escapeHtml(strings.searchPopular || 'Popular searches') +
          '</p><ul class="predictive-search__chips">' +
          popular.map(function (term) {
            return '<li><a class="ds-chip ds-chip--compact" href="' + searchUrl + '?q=' +
              encodeURIComponent(term) + '">' + escapeHtml(term) + '</a></li>';
          }).join('') + '</ul>';
      }

      /* No history and no configured terms means there is nothing honest to
         show, so the panel stays shut rather than opening on empty space. */
      if (!html) {
        close();
        return;
      }

      results.innerHTML = '<div class="predictive-search__inner">' + html + '</div>';
      open(false);
      options = [];
      announce('');
    }

    function render(query, groups) {
      var index = 0;
      var html = groups.map(function (group) {
        if (!group.items.length) return '';
        var body = group.items.map(function (item) {
          var option = predictiveOption(item, index, panelId);
          index += 1;
          return option;
        }).join('');
        return (
          '<div class="predictive-search__group" role="group" aria-label="' + escapeHtml(group.title) + '">' +
          '<p class="predictive-search__heading" aria-hidden="true">' + escapeHtml(group.title) + '</p>' +
          body + '</div>'
        );
      }).join('');

      var total = index;

      if (!total) {
        results.innerHTML =
          '<div class="predictive-search__inner"><p class="predictive-search__empty">' +
          escapeHtml(strings.searchNoResults || 'No results found') + '</p></div>';
        open(false);
        options = [];
        announce(strings.searchNoResults || 'No results found');
        return;
      }

      /* The last option is the way out to the full results page, so keyboard
         users reach it without leaving the listbox. */
      var viewAllLabel = fillString(strings.searchViewAll || 'View all results', 'query', escapeHtml(query));
      html +=
        '<a class="predictive-search__view-all" role="option" id="' + panelId + '-option-' + total +
        '" aria-selected="false" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '">' +
        viewAllLabel + '</a>';

      results.innerHTML = '<div class="predictive-search__inner">' + html + '</div>';
      open(true);
      collectOptions();
      announce(fillString(strings.searchResultsAvailable || '{{ count }} suggestions available', 'count', total));
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var requestQuery = query;

      results.classList.add('is-loading');
      if (!results.hasAttribute('open')) {
        results.innerHTML = predictiveSkeleton();
        open(false);
      }
      announce(strings.searchLoading || 'Searching…');

      var url =
        window.Y10.routes.predictiveSearch + '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,article,page&resources[limit]=4';

      fetch(url, { signal: controller.signal })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          /* A slower earlier request must never overwrite a newer query. */
          if (requestQuery !== input.value.trim()) return;

          var found = (data.resources && data.resources.results) || {};

          var products = (found.products || []).map(function (product) {
            var image = product.image || (product.featured_image && product.featured_image.url) || '';
            var compare = predictivePrice(product.compare_at_price_max || product.compare_at_price);
            var price = predictivePrice(product.price || product.price_min);
            return {
              title: product.title || '',
              url: product.url || '#',
              image: image,
              vendor: product.vendor || '',
              price: product.available === false ? '' : price,
              /* Only shown when the price it would replace is gone. */
              note: product.available === false ? (strings.searchSoldOut || 'Sold out') : '',
              compareAt: compare && price && compare !== price ? compare : ''
            };
          });

          var simple = function (list) {
            return (list || []).map(function (item) {
              var image = item.image || '';
              if (image && typeof image === 'object') image = image.url || '';
              return { title: item.title || '', url: item.url || '#', image: image };
            });
          };

          render(requestQuery, [
            { title: strings.searchProducts || 'Products', items: products },
            { title: strings.searchCollections || 'Collections', items: simple(found.collections) },
            { title: strings.searchArticles || 'Articles', items: simple(found.articles) },
            { title: strings.searchPages || 'Pages', items: simple(found.pages) }
          ]);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          close();
        })
        .then(function () {
          results.classList.remove('is-loading');
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (clear) clear.hidden = query.length === 0;

      window.clearTimeout(debounce);

      if (query.length < 2) {
        if (controller) controller.abort();
        results.classList.remove('is-loading');
        showDiscovery();
        return;
      }

      debounce = window.setTimeout(function () { search(query); }, 200);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length < 2) showDiscovery();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key === 'Enter' && activeIndex > -1 && options[activeIndex]) {
        event.preventDefault();
        window.location.href = options[activeIndex].getAttribute('href');
        return;
      }

      if (!options.length) return;

      var next = activeIndex;
      if (event.key === 'ArrowDown') next = activeIndex + 1 >= options.length ? 0 : activeIndex + 1;
      else if (event.key === 'ArrowUp') next = activeIndex - 1 < 0 ? options.length - 1 : activeIndex - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = options.length - 1;
      else return;

      event.preventDefault();
      setActive(next);
    });

    results.addEventListener('click', function (event) {
      if (!event.target.closest('[data-recent-clear]')) return;
      writeRecentSearches([]);
      showDiscovery();
    });

    /* Pointer and keyboard cursors stay in sync. */
    results.addEventListener('mousemove', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      var index = options.indexOf(option);
      if (index > -1 && index !== activeIndex) setActive(index);
    });

    if (form) {
      form.addEventListener('submit', function () {
        var term = input.value.trim();
        if (!term) return;
        var list = readRecentSearches().filter(function (existing) { return existing !== term; });
        list.unshift(term);
        writeRecentSearches(list);
      });
    }

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) close();
    });
  }

  document.querySelectorAll(selectors.predictiveWrapper).forEach(setupPredictiveSearch);

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-quantity-minus]');
    var plus = event.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;

    var quantity = event.target.closest('[data-quantity]');
    var input = quantity ? quantity.querySelector('[data-quantity-input]') : null;
    if (!input) return;

    var current = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (Number.isNaN(min)) min = 0;

    input.value = plus ? current + 1 : Math.max(min, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var WishlistStore = {
    key: 'y10_wishlist_handles',
    getAll: function () {
      try {
        var handles = JSON.parse(window.localStorage.getItem(this.key) || '[]');
        return Array.isArray(handles) ? handles.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    },
    save: function (handles) {
      window.localStorage.setItem(this.key, JSON.stringify(handles));
      document.dispatchEvent(new CustomEvent('y10:wishlist:updated', { detail: { handles: handles } }));
    },
    has: function (handle) {
      return this.getAll().indexOf(handle) !== -1;
    },
    add: function (handle) {
      var handles = this.getAll();
      if (handles.indexOf(handle) === -1) handles.unshift(handle);
      this.save(handles);
      return handles;
    },
    remove: function (handle) {
      var handles = this.getAll().filter(function (item) {
        return item !== handle;
      });
      this.save(handles);
      return handles;
    },
    toggle: function (handle) {
      return this.has(handle) ? { active: false, handles: this.remove(handle) } : { active: true, handles: this.add(handle) };
    }
  };

  window.Y10 = window.Y10 || {};
  window.Y10.wishlist = WishlistStore;

  /* Beauty Finder history.

     Deliberately an adapter rather than raw localStorage calls: the account
     pages and the finder both talk to this interface, so moving the backing
     store to a customer metafield (through an app proxy) later means replacing
     `read`/`write` here and nothing else. */
  var BeautyHistoryStore = {
    key: 'y10_beauty_history',
    limit: 20,
    read: function () {
      try {
        var entries = JSON.parse(window.localStorage.getItem(this.key) || '[]');
        return Array.isArray(entries) ? entries : [];
      } catch (error) {
        return [];
      }
    },
    write: function (entries) {
      try {
        window.localStorage.setItem(this.key, JSON.stringify(entries.slice(0, this.limit)));
      } catch (error) {
        /* Private browsing: the edit is still shown, just not remembered. */
      }
      document.dispatchEvent(new CustomEvent('y10:beauty-history:updated', { detail: { entries: entries } }));
    },
    getAll: function () {
      return this.read().sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
    },
    getLatest: function () {
      return this.getAll()[0] || null;
    },
    add: function (entry) {
      if (!entry || !entry.title) return null;
      var entries = this.read().filter(function (item) {
        return item.id !== entry.id;
      });
      entries.unshift(entry);
      this.write(entries);
      return entry;
    },
    clear: function () {
      this.write([]);
    }
  };

  window.Y10.beautyHistory = BeautyHistoryStore;

  function setWishlistButtonState(button, active) {
    button.setAttribute('aria-pressed', String(active));
    button.classList.toggle('is-active', active);
    button.removeAttribute('aria-busy');
    button.disabled = false;
    var label = active ? button.getAttribute('data-wishlist-remove-label') : button.getAttribute('data-wishlist-add-label');
    if (label) button.setAttribute('aria-label', label);
  }

  function updateWishlistButtons(scope) {
    var handles = WishlistStore.getAll();
    (scope || document).querySelectorAll(selectors.wishlistButton).forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      setWishlistButtonState(button, handles.indexOf(handle) !== -1);
    });
  }

  function updateWishlistCounters() {
    var count = WishlistStore.getAll().length;
    document.querySelectorAll(selectors.wishlistCount).forEach(function (counter) {
      counter.textContent = String(count);
      /* Badges hide at zero. The previous version only ever re-evaluated
         counters that were still hidden, so once a badge had been shown it
         stayed on screen reading "0" after the last item was removed. The
         page's own count is not a badge and always shows its number. */
      if (counter.hasAttribute('data-wishlist-badge')) {
        counter.hidden = count === 0;
      }
    });
  }

  /* Every render claims a token. Adding several items quickly starts several
     renders, and without this the slowest one wins and paints a stale grid. */
  var wishlistRenderToken = 0;

  function renderWishlistPage(page) {
    var grid = page.querySelector(selectors.wishlistGrid);
    var empty = page.querySelector(selectors.wishlistEmpty);
    var status = page.querySelector(selectors.wishlistStatus);
    var layout = page.querySelector('[data-wishlist-layout]');
    var actions = page.querySelector('[data-wishlist-actions]');
    var handles = WishlistStore.getAll();
    if (!grid || !empty) return;

    updateWishlistCounters();

    function showEmpty() {
      grid.innerHTML = '';
      if (layout) layout.hidden = true;
      if (actions) actions.hidden = true;
      empty.hidden = false;
      if (status) status.textContent = '';
    }

    if (!handles.length) {
      showEmpty();
      return;
    }

    empty.hidden = true;
    if (layout) layout.hidden = false;
    if (actions) actions.hidden = false;
    if (status) status.textContent = window.Y10.strings.wishlistLoading || 'Loading your wishlist...';

    wishlistRenderToken += 1;
    var token = wishlistRenderToken;

    /* The row carries the price, availability and variant, so the page never
       has to guess any of it from what is on screen. */
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=wishlist-row')
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-wishlist-row]');
        })
        .catch(function () {
          return null;
        });
    })).then(function (rows) {
      /* A newer render started while this one was in flight. */
      if (token !== wishlistRenderToken) return;

      grid.innerHTML = '';
      var loaded = 0;
      rows.forEach(function (row) {
        if (row) {
          grid.appendChild(row);
          loaded += 1;
        }
      });

      updateWishlistButtons(grid);
      if (status) status.textContent = loaded === handles.length ? (window.Y10.strings.wishlistLoaded || '') : (window.Y10.strings.wishlistError || '');

      if (!loaded) {
        showEmpty();
        return;
      }

      refreshWishlistWorkspace(page);
    });
  }

  /* ---- Wishlist workspace -------------------------------------------------
     Tabs, sort, selection, the summary and Load more all read the same set of
     rendered rows, so there is one source of truth on the page and none of the
     figures are written into the markup.
  ------------------------------------------------------------------------- */

  var WISHLIST_PAGE_SIZE_ATTR = 'data-initial-rows';

  function wishlistRows(page) {
    return Array.prototype.slice.call(page.querySelectorAll('[data-wishlist-row]'));
  }

  function wishlistRowAvailable(row) {
    return row.getAttribute('data-available') === 'true';
  }

  function wishlistState(page) {
    if (!page.y10Wishlist) {
      page.y10Wishlist = { tab: 'all', sort: 'date-added', shown: 0 };
    }
    return page.y10Wishlist;
  }

  function wishlistMoney(cents) {
    return formatMoney(cents, (window.Y10 && window.Y10.moneyFormat) || '${{amount}}');
  }

  function sortWishlistRows(page, rows) {
    var state = wishlistState(page);
    var sorted = rows.slice();

    if (state.sort === 'price-ascending' || state.sort === 'price-descending') {
      sorted.sort(function (a, b) {
        var diff = Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'));
        return state.sort === 'price-ascending' ? diff : -diff;
      });
    } else if (state.sort === 'title-ascending') {
      sorted.sort(function (a, b) {
        return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
      });
    }
    /* date-added is the store's own order, which is what the rows arrived in. */

    var grid = page.querySelector(selectors.wishlistGrid);
    sorted.forEach(function (row) {
      grid.appendChild(row);
    });

    return sorted;
  }

  function refreshWishlistWorkspace(page) {
    var state = wishlistState(page);
    var rows = wishlistRows(page);
    if (!rows.length) return;

    var ordered = sortWishlistRows(page, rows);

    var inStock = ordered.filter(wishlistRowAvailable);
    var outOfStock = ordered.filter(function (row) {
      return !wishlistRowAvailable(row);
    });

    var counts = { all: ordered.length, 'in-stock': inStock.length, 'out-of-stock': outOfStock.length };
    Object.keys(counts).forEach(function (key) {
      var node = page.querySelector('[data-wishlist-tab-count="' + key + '"]');
      if (node) node.textContent = String(counts[key]);
    });

    var visible = ordered;
    if (state.tab === 'in-stock') visible = inStock;
    if (state.tab === 'out-of-stock') visible = outOfStock;

    /* Load more works on the visible set, so switching tabs does not leave a
       button that reveals nothing. */
    var pageSize = parseInt(page.getAttribute(WISHLIST_PAGE_SIZE_ATTR), 10) || 6;
    if (!state.shown || state.shown < pageSize) state.shown = pageSize;

    ordered.forEach(function (row) {
      var index = visible.indexOf(row);
      row.hidden = index === -1 || index >= state.shown;
      if (row.hidden) {
        var box = row.querySelector('[data-wishlist-select]');
        if (box) box.checked = false;
      }
    });

    var tabEmpty = page.querySelector('[data-wishlist-tab-empty]');
    if (tabEmpty) tabEmpty.hidden = visible.length > 0;

    var loadMore = page.querySelector('[data-wishlist-load-more]');
    if (loadMore) loadMore.hidden = visible.length <= state.shown;

    /* Summary: only the items that can actually be bought are totalled, and
       shipping and tax stay with checkout where they are decided. */
    var total = inStock.reduce(function (sum, row) {
      return sum + Number(row.getAttribute('data-price') || 0);
    }, 0);

    var countNode = page.querySelector('[data-wishlist-summary-count]');
    if (countNode) countNode.textContent = String(inStock.length);

    var totalNode = page.querySelector('[data-wishlist-summary-total]');
    if (totalNode) totalNode.textContent = wishlistMoney(total);

    var estimateNode = page.querySelector('[data-wishlist-summary-estimate]');
    if (estimateNode) estimateNode.textContent = wishlistMoney(total);

    page.querySelectorAll('[data-wishlist-add-all-label]').forEach(function (label) {
      var base = window.Y10.strings.wishlistAddAll || 'Add all to cart';
      label.textContent = inStock.length ? base + ' (' + inStock.length + ')' : base;
    });

    page.querySelectorAll('[data-wishlist-add-all]').forEach(function (button) {
      button.disabled = inStock.length === 0;
    });

    var notice = page.querySelector('[data-wishlist-oos-notice]');
    if (notice) {
      notice.hidden = outOfStock.length === 0;
      /* "1 items are out of stock" is the kind of thing that makes a page look
         unfinished, so the sentence agrees with the number. */
      var heading = notice.querySelector('[data-wishlist-oos-heading]');
      if (heading) {
        heading.textContent = outOfStock.length === 1
          ? '1 item is out of stock'
          : outOfStock.length + ' items are out of stock';
      }
    }

    refreshWishlistSelection(page);
  }

  function refreshWishlistSelection(page) {
    var selected = page.querySelectorAll('[data-wishlist-row]:not([hidden]) [data-wishlist-select]:checked');
    var bulk = page.querySelector('[data-wishlist-bulk]');
    if (!bulk) return;

    bulk.hidden = selected.length === 0;
    var count = bulk.querySelector('[data-wishlist-selected-count]');
    if (count) count.textContent = String(selected.length);
  }

  /* ---- Wishlist to cart ---------------------------------------------------
     One path into Shopify's own cart for every button on this page. Nothing
     here builds a price or a checkout payload.
  ------------------------------------------------------------------------- */

  function addVariantsToCart(items, source) {
    if (!items.length || !window.Y10 || !window.Y10.routes.cartAdd) {
      return Promise.resolve({ added: 0 });
    }

    return fetch(window.Y10.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || window.Y10.strings.cartError);
          }
          return data;
        });
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('y10:cart:added', { detail: { source: source } }));
        return { added: items.length, cart: data };
      });
  }

  function wishlistRowItem(row) {
    var id = row.getAttribute('data-variant-id');
    if (!id) return null;
    if (!wishlistRowAvailable(row)) return null;
    if (row.getAttribute('data-needs-choice') === 'true') return null;
    return { id: Number(id), quantity: 1 };
  }

  function announceWishlist(page, message) {
    var status = page.querySelector(selectors.wishlistStatus);
    if (status) status.textContent = message;
    showCartToast(message);
  }

  /* Add the ones that can be added, leave the rest alone, and say what
     happened. Silence after a partial success is the thing to avoid. */
  function addWishlistRows(page, rows, source, removeAfter) {
    var items = [];
    var addable = [];
    var skipped = 0;

    rows.forEach(function (row) {
      var item = wishlistRowItem(row);
      if (item) {
        items.push(item);
        addable.push(row);
      } else {
        skipped += 1;
      }
    });

    if (!items.length) {
      announceWishlist(page, window.Y10.strings.wishlistAddedNone || 'Nothing could be added');
      return Promise.resolve();
    }

    return addVariantsToCart(items, source)
      .then(function () {
        var message = (window.Y10.strings.wishlistAddedSome || 'COUNT added to cart').replace('COUNT', items.length);
        if (skipped) {
          message += ' — ' + (window.Y10.strings.wishlistSkipped || 'COUNT skipped').replace('COUNT', skipped);
        }
        announceWishlist(page, message);

        /* Move only gives up the saved item once the cart really has it. */
        if (removeAfter) {
          addable.forEach(function (row) {
            WishlistStore.remove(row.getAttribute('data-handle'));
          });
        }
      })
      .catch(function (error) {
        announceWishlist(page, error.message || window.Y10.strings.cartError);
      });
  }

  document.addEventListener('click', function (event) {
    var page = event.target.closest(selectors.wishlistPage);
    if (!page) return;

    var tab = event.target.closest('[data-wishlist-tab]');
    if (tab) {
      var state = wishlistState(page);
      state.tab = tab.getAttribute('data-wishlist-tab');
      state.shown = 0;
      page.querySelectorAll('[data-wishlist-tab]').forEach(function (button) {
        var active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      refreshWishlistWorkspace(page);
      return;
    }

    var view = event.target.closest('[data-wishlist-view]');
    if (view) {
      var isGrid = view.getAttribute('data-wishlist-view') === 'grid';
      var rowsHost = page.querySelector(selectors.wishlistGrid);
      if (rowsHost) rowsHost.classList.toggle('is-grid-view', isGrid);
      page.querySelectorAll('[data-wishlist-view]').forEach(function (button) {
        var active = button === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      return;
    }

    var loadMoreButton = event.target.closest('[data-wishlist-load-more-button]');
    if (loadMoreButton) {
      var loadState = wishlistState(page);
      loadState.shown += parseInt(page.getAttribute(WISHLIST_PAGE_SIZE_ATTR), 10) || 6;
      refreshWishlistWorkspace(page);
      return;
    }

    var addRow = event.target.closest('[data-wishlist-add]');
    if (addRow) {
      var row = addRow.closest('[data-wishlist-row]');
      if (row) addWishlistRows(page, [row], row.querySelector('img'), false);
      return;
    }

    var moveRow = event.target.closest('[data-wishlist-move]');
    if (moveRow) {
      var moving = moveRow.closest('[data-wishlist-row]');
      if (moving) addWishlistRows(page, [moving], moving.querySelector('img'), true);
      return;
    }

    var addAll = event.target.closest('[data-wishlist-add-all]');
    if (addAll) {
      addWishlistRows(page, wishlistRows(page).filter(wishlistRowAvailable), addAll, false);
      return;
    }

    var moveSelected = event.target.closest('[data-wishlist-move-selected]');
    if (moveSelected) {
      var chosen = wishlistRows(page).filter(function (item) {
        var box = item.querySelector('[data-wishlist-select]');
        return box && box.checked;
      });
      addWishlistRows(page, chosen, moveSelected, true);
      return;
    }

    var removeSelected = event.target.closest('[data-wishlist-remove-selected]');
    if (removeSelected) {
      wishlistRows(page).forEach(function (item) {
        var box = item.querySelector('[data-wishlist-select]');
        if (box && box.checked) WishlistStore.remove(item.getAttribute('data-handle'));
      });
      return;
    }

    var recAdd = event.target.closest('[data-wishlist-rec-add]');
    if (recAdd) {
      addVariantsToCart([{ id: Number(recAdd.getAttribute('data-wishlist-rec-add')), quantity: 1 }], recAdd)
        .catch(function (error) {
          announceWishlist(page, error.message || window.Y10.strings.cartError);
        });
      return;
    }

    /* Checkout must never be a door into an empty cart. */
    var checkout = event.target.closest('[data-wishlist-checkout]');
    if (checkout) {
      event.preventDefault();
      CartStore.load(true).then(function (cart) {
        if (cart && cart.item_count > 0) {
          window.location.href = window.Y10.routes.cart;
          return;
        }
        announceWishlist(page, window.Y10.strings.wishlistCheckoutEmpty || 'Add items to your cart first');
      });
      return;
    }

    var share = event.target.closest('[data-wishlist-share]');
    if (share) {
      var url = window.location.href;
      var shareData = { title: document.title, url: url };

      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
        return;
      }

      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          announceWishlist(page, window.Y10.strings.wishlistShareCopied || 'Wishlist link copied');
        }).catch(function () {
          announceWishlist(page, window.Y10.strings.wishlistShareFailed || '');
        });
      }
    }
  });

  document.addEventListener('change', function (event) {
    var page = event.target.closest(selectors.wishlistPage);
    if (!page) return;

    if (event.target.matches('[data-wishlist-select]')) {
      refreshWishlistSelection(page);
      return;
    }

    if (event.target.matches('[data-wishlist-sort]')) {
      wishlistState(page).sort = event.target.value;
      refreshWishlistWorkspace(page);
    }
  });

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest(selectors.wishlistButton);
    if (wishlistButton) {
      var handle = wishlistButton.getAttribute('data-product-handle');
      if (!handle) return;
      wishlistButton.disabled = true;
      wishlistButton.setAttribute('aria-busy', 'true');
      var result = WishlistStore.toggle(handle);
      setWishlistButtonState(wishlistButton, result.active);
      wishlistButton.classList.add('is-success');
      window.setTimeout(function () {
        wishlistButton.classList.remove('is-success');
      }, 420);
      return;
    }

    var wishlistRemove = event.target.closest(selectors.wishlistRemove);
    if (wishlistRemove) {
      WishlistStore.remove(wishlistRemove.getAttribute('data-wishlist-remove'));
      /* The store change already re-renders every wishlist page. */
    }
  });

  document.addEventListener('y10:wishlist:updated', function () {
    updateWishlistCounters();
    updateWishlistButtons(document);
    /* The page has to follow the store, not just the remove button on it: a
       heart toggled on a product card or in another tab changes what the
       wishlist contains, and the grid was previously left showing the old
       set. The render token keeps overlapping renders in order. */
    document.querySelectorAll(selectors.wishlistPage).forEach(renderWishlistPage);
  });

  document.querySelectorAll(selectors.wishlistPage).forEach(renderWishlistPage);
  updateWishlistCounters();
  updateWishlistButtons(document);

  document.querySelectorAll(selectors.rail).forEach(function (rail) {
    var viewport = rail.querySelector(selectors.railViewport);
    var prev = rail.querySelector(selectors.railPrev);
    var next = rail.querySelector(selectors.railNext);
    if (!viewport) return;

    function scrollRail(direction) {
      viewport.scrollBy({
        left: direction * Math.max(240, viewport.clientWidth * 0.85),
        behavior: 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollRail(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollRail(1);
      });
    }
  });

  document.addEventListener('submit', function (event) {
    var productForm = event.target.closest(selectors.productForm + ' form');
    if (!productForm || !window.Y10 || !window.Y10.routes.cartAdd) return;

    event.preventDefault();

    var submit = productForm.querySelector(selectors.addToCart);
    var text = productForm.querySelector(selectors.addToCartText);
    var error = productForm.querySelector(selectors.productFormError);
    var originalText = text ? text.textContent : '';

    /* The sticky bar submits this same form, so it echoes the same states
       rather than tracking its own. */
    var mainSection = productForm.closest(selectors.mainProduct);
    var mirror = mainSection ? mainSection.querySelector(selectors.stickyAtcText) : null;
    var mirrorButton = mainSection ? mainSection.querySelector(selectors.stickyAtcButton) : null;
    var setLabel = function (value) {
      if (text) text.textContent = value;
      if (mirror) mirror.textContent = value;
    };

    if (submit) {
      submit.setAttribute('disabled', 'disabled');
      submit.classList.add('is-loading');
    }
    if (mirrorButton) {
      mirrorButton.setAttribute('disabled', 'disabled');
      mirrorButton.classList.add('is-loading');
    }
    setLabel(window.Y10.strings.adding);
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    fetch(window.Y10.routes.cartAdd + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(productForm)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || window.Y10.strings.cartError);
          });
        }
        return response.json();
      })
      .then(function () {
        setLabel(window.Y10.strings.added);
        if (submit) submit.classList.add('is-added');
        if (mirrorButton) mirrorButton.classList.add('is-added');

        var media = productForm.closest('[data-main-product], [data-product-card]');
        var source = media ? media.querySelector('img') : null;
        document.dispatchEvent(new CustomEvent('y10:cart:added', { detail: { source: source || submit, form: productForm } }));

        setTimeout(function () {
          /* A variant change during the confirmation window rewrites the label.
             Restoring a stale capture would undo it, so the resting label is
             read back from the button. */
          setLabel((submit && submit.dataset.restingLabel) || originalText);
          if (submit) submit.classList.remove('is-added');
          if (mirrorButton) mirrorButton.classList.remove('is-added');
        }, ADDED_STATE_MS);
      })
      .catch(function (err) {
        if (error) {
          error.textContent = err.message || window.Y10.strings.cartError;
          error.hidden = false;
        }
        setLabel((submit && submit.dataset.restingLabel) || originalText);
      })
      .finally(function () {
        if (submit) submit.classList.remove('is-loading');
        if (mirrorButton) mirrorButton.classList.remove('is-loading');
        window.setTimeout(function () {
          if (submit) submit.removeAttribute('disabled');
          if (mirrorButton) mirrorButton.removeAttribute('disabled');
        }, 600);
      });
  });

  document.querySelectorAll(selectors.hero).forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll(selectors.heroSlide));
    var dots = Array.prototype.slice.call(hero.querySelectorAll(selectors.heroDot));
    var prev = hero.querySelector(selectors.heroPrev);
    var next = hero.querySelector(selectors.heroNext);
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-autoplay-interval'), 10) || 5000;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeIndex = 0;
    var timer;

    if (slides.length < 2) return;

    function setActiveSlide(index) {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        if (isActive) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (!autoplay || prefersReducedMotion) return;
      stopAutoplay();
      timer = window.setInterval(function () {
        setActiveSlide(activeIndex + 1);
      }, interval);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(activeIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(parseInt(dot.getAttribute('data-slide-index'), 10) || 0);
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    setActiveSlide(0);
    startAutoplay();
  });

  document.querySelectorAll(selectors.featuredProducts).forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll(selectors.featuredProductsTab));
    var panels = Array.prototype.slice.call(section.querySelectorAll(selectors.featuredProductsPanel));

    function setActiveTab(index) {
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setActiveTab(index);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (typeof nextIndex === 'number') {
          event.preventDefault();
          tabs[nextIndex].focus();
          setActiveTab(nextIndex);
        }
      });
    });

    section.querySelectorAll(selectors.featuredProductsRail).forEach(function (rail) {
      var viewport = rail.querySelector(selectors.featuredProductsViewport);
      var prev = rail.querySelector(selectors.featuredProductsPrev);
      var next = rail.querySelector(selectors.featuredProductsNext);
      var dotsWrapper = rail.parentElement ? rail.parentElement.querySelector(selectors.featuredProductsDots) : null;
      var dots = dotsWrapper ? Array.prototype.slice.call(dotsWrapper.children) : [];

      if (!viewport) return;

      function updateDots() {
        if (!dots.length) return;
        var maxScroll = Math.max(1, viewport.scrollWidth - viewport.clientWidth);
        var progress = viewport.scrollLeft / maxScroll;
        var active = Math.round(progress * (dots.length - 1));
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === active);
        });
      }

      function scrollProducts(direction) {
        viewport.scrollBy({
          left: direction * Math.max(260, viewport.clientWidth * 0.9),
          behavior: 'smooth'
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollProducts(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollProducts(1);
        });
      }

      viewport.addEventListener('scroll', updateDots, { passive: true });
      updateDots();
    });
  });

  /* The search sheet opens through the shared panel system, so it inherits the
     overlay, scroll lock, focus move and focus return every other panel uses. */
  document.addEventListener('click', function (event) {
    var sheetOpen = event.target.closest(selectors.searchSheetOpen);
    if (sheetOpen) {
      var sheet = document.querySelector(selectors.searchSheet);
      if (!sheet) return;
      /* openPanel remembers whatever had focus so it can restore it on close.
         A pointer click does not always focus the button, so make it explicit. */
      sheetOpen.focus();
      sheetOpen.setAttribute('aria-expanded', 'true');
      openPanel(sheet);
      var sheetInput = sheet.querySelector(selectors.predictiveInput);
      if (sheetInput) sheetInput.focus();
      return;
    }

    var filterOpen = event.target.closest(selectors.collectionFilterOpen);
    if (filterOpen) {
      var filterDrawer = document.querySelector(selectors.collectionFilterDrawer);
      if (filterDrawer) {
        filterOpen.setAttribute('aria-expanded', 'true');
        openPanel(filterDrawer);
      }
      return;
    }

    /* Grid and list are the same cards in a different arrangement, so the
       switch only changes a class on the grid. */
    var viewButton = event.target.closest(selectors.collectionViewButton);
    if (viewButton) {
      var grid = document.querySelector(selectors.collectionGrid);
      if (!grid) return;

      var isList = viewButton.getAttribute('data-view') === 'list';
      grid.classList.toggle('is-list-view', isList);

      document.querySelectorAll(selectors.collectionViewButton).forEach(function (button) {
        var isActive = button === viewButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      return;
    }

  });

  document.addEventListener('change', function (event) {
    if (event.target.matches(selectors.collectionSortSelect) && event.target.form) {
      event.target.form.submit();
    }
  });

  document.addEventListener('click', function (event) {
    var loadMore = event.target.closest(selectors.loadMoreButton);
    if (!loadMore) return;

    event.preventDefault();
    var url = loadMore.getAttribute('href');
    var grid = document.querySelector(selectors.collectionGrid);
    if (!url || !grid) return;

    loadMore.setAttribute('aria-disabled', 'true');

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextItems = doc.querySelectorAll('.collection-products__item');
        nextItems.forEach(function (item) {
          grid.appendChild(item);
        });

        var nextButton = doc.querySelector(selectors.loadMoreButton);
        if (nextButton) {
          loadMore.setAttribute('href', nextButton.getAttribute('href'));
          loadMore.removeAttribute('aria-disabled');
        } else {
          loadMore.remove();
        }
      })
      .catch(function () {
        loadMore.removeAttribute('aria-disabled');
      });
  });
  document.querySelectorAll(selectors.faq).forEach(function (faq) {
    var input = faq.querySelector(selectors.faqSearch);
    var clear = faq.querySelector(selectors.faqSearchClear);
    var status = faq.querySelector(selectors.faqStatus);
    var empty = faq.querySelector(selectors.faqEmpty);
    var items = Array.prototype.slice.call(faq.querySelectorAll(selectors.faqItem));
    var groups = Array.prototype.slice.call(faq.querySelectorAll(selectors.faqGroup));
    var buttons = Array.prototype.slice.call(faq.querySelectorAll('button' + selectors.faqCategory));
    var activeCategory = 'all';

    if (!items.length) return;

    function strings() {
      return window.Y10 && window.Y10.strings ? window.Y10.strings : {};
    }

    function applyFilters() {
      var query = input && input.value ? input.value.trim().toLowerCase() : '';
      var visible = 0;

      items.forEach(function (item) {
        var terms = item.getAttribute('data-faq-terms') || '';
        var category = item.getAttribute('data-faq-category') || '';
        var matchesQuery = !query || terms.indexOf(query) !== -1;
        var matchesCategory = activeCategory === 'all' || category === activeCategory;
        var show = matchesQuery && matchesCategory;

        item.hidden = !show;
        if (show) {
          visible += 1;
        } else {
          item.open = false;
        }
      });

      groups.forEach(function (group) {
        var groupItems = Array.prototype.slice.call(group.querySelectorAll(selectors.faqItem));
        var hasVisible = groupItems.some(function (item) {
          return !item.hidden;
        });
        group.hidden = !hasVisible;
      });

      if (empty) empty.hidden = visible !== 0;
      if (clear) clear.hidden = query.length === 0;

      if (status) {
        if (!query) {
          status.textContent = '';
        } else if (visible === 0) {
          status.textContent = strings().faqNoResults || '';
        } else {
          var template = visible === 1 ? strings().faqResultsOne : strings().faqResults;
          status.textContent = (template || '').replace('COUNT', visible);
        }
      }
    }

    if (input) {
      input.addEventListener('input', applyFilters);
      input.addEventListener('search', applyFilters);
    }

    if (clear) {
      clear.addEventListener('click', function () {
        if (!input) return;
        input.value = '';
        applyFilters();
        input.focus();
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.getAttribute('data-faq-category') || 'all';
        buttons.forEach(function (other) {
          var isActive = other === button;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    applyFilters();
  });

  document.querySelectorAll(selectors.policyToc).forEach(function (toc) {
    var list = toc.querySelector(selectors.policyTocList);
    if (!list) return;

    var body = document.querySelector(selectors.policyBody);
    if (body) {
      var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
      headings.forEach(function (heading, index) {
        if (!heading.id) {
          var slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          heading.id = slug ? 'policy-' + slug : 'policy-section-' + (index + 1);
        }

        var item = document.createElement('li');
        var link = document.createElement('a');
        link.setAttribute('href', '#' + heading.id);
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.insertBefore(item, list.children[index] || null);
      });
    }

    toc.hidden = list.children.length === 0;
  });

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function announceCart(message) {
    var region = document.querySelector(selectors.cartLiveRegion);
    if (region) region.textContent = message;
  }

  function popCartBadges() {
    document.querySelectorAll(selectors.cartCount).forEach(function (badge) {
      if (badge.hidden) return;
      badge.classList.remove('is-bumped');
      void badge.offsetWidth;
      badge.classList.add('is-bumped');
    });
  }

  function getCartTarget() {
    var nav = document.querySelector(selectors.mobileNav);
    if (nav && getComputedStyle(nav).display !== 'none') {
      var navCart = nav.querySelector('[data-cart-count]');
      if (navCart) return navCart.closest('.mobile-nav__icon') || navCart;
    }
    var headerCart = document.querySelector('.site-header__icons [data-cart-count]');
    return headerCart ? headerCart.closest('.icon-button') : null;
  }

  function flyToCart(sourceEl) {
    if (prefersReducedMotion()) return;

    var target = getCartTarget();
    if (!target || !sourceEl) return;

    var from = sourceEl.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var flyer = document.createElement('span');
    flyer.className = 'fly-to-cart';

    var image = sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img');
    if (image && image.currentSrc) {
      flyer.style.backgroundImage = 'url("' + image.currentSrc + '")';
    } else {
      flyer.classList.add('fly-to-cart--dot');
    }

    flyer.style.left = from.left + from.width / 2 - 24 + 'px';
    flyer.style.top = from.top + from.height / 2 - 24 + 'px';
    document.body.appendChild(flyer);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    var animation = flyer.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px, ' + (dy * 0.35 - 60) + 'px) scale(.8)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.3)', opacity: 0.2 }
      ],
      { duration: 420, easing: 'cubic-bezier(.4, 0, .2, 1)' }
    );

    animation.onfinish = function () {
      flyer.remove();
      target.classList.remove('is-bumped');
      void target.offsetWidth;
      target.classList.add('is-bumped');
    };
  }

  function showCartToast(message) {
    var existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 2600);
  }

  function refreshCartSheet() {
    var drawer = document.querySelector(selectors.cartDrawer);
    if (!drawer) return Promise.resolve();

    /* The drawer is a header-group section, so it renders on every URL. */
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextBody = doc.querySelector(selectors.cartSheetSource);
        var nextFooter = doc.querySelector('.cart-drawer__footer');
        var nextCount = doc.querySelector('[data-cart-drawer-count]');
        var body = drawer.querySelector(selectors.cartSheetSource);
        var footer = drawer.querySelector('.cart-drawer__footer');
        var count = drawer.querySelector('[data-cart-drawer-count]');

        if (nextBody && body) body.innerHTML = nextBody.innerHTML;
        if (nextFooter && footer) {
          footer.innerHTML = nextFooter.innerHTML;
          footer.hidden = nextFooter.hidden;
        }
        if (nextCount && count) count.textContent = nextCount.textContent;
      })
      .catch(function () {});
  }

  /* ---- Cart line controls --------------------------------------------------
     One implementation for the drawer and the cart page. Quantity and removal
     go through the cart service; the response is the authoritative cart, so no
     surface keeps a private counter. Feedback is localized to the row being
     changed rather than replacing the whole interface.
  ------------------------------------------------------------------------- */

  function refreshCartPage() {
    var page = document.querySelector(selectors.cartPage);
    if (!page) return Promise.resolve();

    return fetch(window.location.pathname + '?section_id=main-cart')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.cart-page');
        var current = document.querySelector('.cart-page');
        if (!next || !current) return;

        /* Preserve an in-progress note the shopper has not committed yet. */
        var note = current.querySelector(selectors.cartNote);
        var pending = note && note.value !== note.defaultValue ? note.value : null;

        current.innerHTML = next.innerHTML;

        var nextNote = current.querySelector(selectors.cartNote);
        if (nextNote && pending !== null) nextNote.value = pending;

        updateWishlistButtons(current);
      })
      .catch(function () {});
  }

  var cartLineBusy = false;

  function setLineBusy(line, busy) {
    line.classList.toggle('is-busy', busy);
    line.querySelectorAll('button').forEach(function (button) {
      button.disabled = busy;
    });
  }

  function changeCartLine(line, quantity) {
    if (cartLineBusy) return;
    var key = line.getAttribute('data-cart-line');
    if (!key) return;

    cartLineBusy = true;
    setLineBusy(line, true);

    CartStore.change(key, quantity)
      .then(function () {
        return Promise.all([refreshCartSheet(), refreshCartPage()]);
      })
      .then(function () {
        announceCart(window.Y10.strings.cartUpdated || '');
      })
      .catch(function () {
        /* CartStore already surfaced the reason and re-read the real cart. */
        if (document.contains(line)) setLineBusy(line, false);
      })
      .then(function () {
        cartLineBusy = false;
        if (document.contains(line)) setLineBusy(line, false);
      });
  }

  document.addEventListener('click', function (event) {
    var line = event.target.closest(selectors.cartDrawerLine);
    if (!line) return;

    var quantityNode = line.querySelector(selectors.cartLineQuantity);
    var current = quantityNode ? parseInt(quantityNode.textContent, 10) || 0 : 0;

    if (event.target.closest(selectors.cartLineIncrease)) {
      changeCartLine(line, current + 1);
    } else if (event.target.closest(selectors.cartLineDecrease)) {
      changeCartLine(line, Math.max(0, current - 1));
    } else if (event.target.closest(selectors.cartLineRemove)) {
      changeCartLine(line, 0);
    }
  });

  /* Cart note is saved on blur so it survives a section re-render. */
  document.addEventListener('change', function (event) {
    var note = event.target.closest(selectors.cartNote);
    if (!note || !window.Y10 || !window.Y10.routes.cart) return;

    fetch(window.Y10.routes.cart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        note.defaultValue = note.value;
        CartStore.publish(cart);
      })
      .catch(function () {});
  });

  function afterAddToCart(sourceEl) {
    flyToCart(sourceEl);
    announceCart(window.Y10.strings.cartAdded || 'Added to cart');
    showCartToast(window.Y10.strings.cartAdded || 'Added to cart');

    setTimeout(popCartBadges, 260);

    /* One coordinated sequence: authoritative cart first, then the badge and
       purchase surfaces settle, then the sheet opens where the architecture
       already did so. */
    Promise.all([CartStore.load(true), refreshCartSheet()]).then(function () {
      var drawer = document.querySelector(selectors.cartDrawer);
      if (drawer && window.matchMedia('(max-width: 989px)').matches) openPanel(drawer);
    });
  }

  document.addEventListener('y10:cart:added', function (event) {
    afterAddToCart(event.detail && event.detail.source);
  });

  /* ---- Complete the look: rail navigation ----------------------------------
     The arrows only exist when the set actually overflows its column, so a
     pair of products never gets controls that do nothing.
  ------------------------------------------------------------------------- */

  document.querySelectorAll('.complete-look').forEach(function (module) {
    var rail = module.querySelector('[data-complete-look-rail]');
    var nav = module.querySelector('[data-complete-look-nav]');
    if (!rail || !nav) return;

    var prev = nav.querySelector('[data-complete-look-prev]');
    var next = nav.querySelector('[data-complete-look-next]');

    var sync = function () {
      var overflows = rail.scrollWidth - rail.clientWidth > 1;
      nav.hidden = !overflows;
      if (!overflows) return;

      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    };

    /* One product plus its connector is the natural step. */
    var step = function (direction) {
      var item = rail.querySelector('.complete-look__item');
      var distance = item ? item.getBoundingClientRect().width + 52 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(rail);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  });

  /* ---- Complete the look ---------------------------------------------------
     Adds every purchasable variant in one cart request, then hands off to the
     same post-add sequence every other surface uses.
  ------------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-complete-look-add]');
    if (!trigger || !window.Y10 || !window.Y10.routes.cartAdd) return;

    var ids = (trigger.getAttribute('data-variant-ids') || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean);
    if (!ids.length) return;

    var label = trigger.querySelector('[data-complete-look-label]');
    var restingLabel = label ? label.textContent : '';

    trigger.disabled = true;
    trigger.classList.add('is-loading');
    if (label) label.textContent = window.Y10.strings.adding;

    fetch(window.Y10.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || window.Y10.strings.cartError);
          return data;
        });
      })
      .then(function () {
        if (label) label.textContent = window.Y10.strings.added;
        document.dispatchEvent(new CustomEvent('y10:cart:added', {
          detail: { source: trigger.closest('.complete-look') }
        }));
        window.setTimeout(function () {
          if (label) label.textContent = restingLabel;
        }, ADDED_STATE_MS);
      })
      .catch(function (error) {
        showCartToast(error.message || window.Y10.strings.cartError);
        announceCart(error.message || window.Y10.strings.cartError);
        if (label) label.textContent = restingLabel;
      })
      .then(function () {
        trigger.disabled = false;
        trigger.classList.remove('is-loading');
      });
  });

  /* Condensing sticky header ------------------------------------------------ */

  document.querySelectorAll(selectors.condenseHeader).forEach(function (header) {
    var threshold = 240;
    var condensed = false;
    var ticking = false;

    /* Reserve the full header height so condensing never moves page content. */
    var spacer = document.createElement('div');
    spacer.className = 'site-header__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.parentNode.insertBefore(spacer, header.nextSibling);

    function measure() {
      if (condensed) return;
      spacer.style.height = header.offsetHeight + 'px';
    }

    function update() {
      var shouldCondense = window.scrollY > threshold;
      if (shouldCondense !== condensed) {
        if (shouldCondense) measure();
        condensed = shouldCondense;
        header.classList.toggle('is-condensed', condensed);
        document.body.classList.toggle('has-condensed-header', condensed);
      }
      ticking = false;
    }

    measure();
    window.addEventListener('resize', function () {
      if (!condensed) measure();
    }, { passive: true });

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  });

  /* Mega menu — hover intent, keyboard and escape ---------------------------

     One controller for the whole navigation rather than one per item. That is
     what makes crossing from a nav item into its own panel — or sideways onto
     the next item — free of the flicker the previous per-item mouseleave
     handler produced: the close is always scheduled, never immediate, and any
     re-entry anywhere in the header cancels it.
  ------------------------------------------------------------------------- */

  (function setUpMegaMenu() {
    var header = document.querySelector(selectors.siteHeader);
    var nav = header && header.querySelector('[data-y10-nav]');
    if (!nav) return;

    var items = Array.prototype.slice.call(nav.querySelectorAll(selectors.megaItem));
    if (!items.length) return;

    var OPEN_DELAY = 100;
    var CLOSE_DELAY = 160;
    var openTimer = null;
    var closeTimer = null;
    var current = null;

    function panelFor(item) {
      return item.querySelector(selectors.megaPanel);
    }

    function triggerFor(item) {
      return item.querySelector(selectors.megaTrigger);
    }

    function clearTimers() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function close(item) {
      if (!item) return;
      var panel = panelFor(item);
      var trigger = triggerFor(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (!panel) return;
      panel.classList.remove('is-open');
      /* Wait out the fade before hiding, so the panel does not vanish mid
         transition — but only if it is still closed by then. */
      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 160);
    }

    function open(item) {
      if (current === item) return;
      if (current) close(current);
      current = item;

      var panel = panelFor(item);
      var trigger = triggerFor(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (!panel) return;
      panel.hidden = false;
      /* Next frame, so the transition has a hidden->visible edge to animate. */
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
    }

    function closeAll(immediate) {
      clearTimers();
      var item = current;
      current = null;
      if (!item) return;
      if (immediate) {
        var panel = panelFor(item);
        var trigger = triggerFor(item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.classList.remove('is-open');
          panel.hidden = true;
        }
        return;
      }
      close(item);
    }

    function scheduleOpen(item) {
      clearTimers();
      /* Switching between two open menus should feel instant; the intent
         delay only guards the first open. */
      if (current) {
        open(item);
        return;
      }
      openTimer = window.setTimeout(function () {
        open(item);
      }, OPEN_DELAY);
    }

    function scheduleClose() {
      clearTimers();
      closeTimer = window.setTimeout(function () {
        closeAll(false);
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var trigger = triggerFor(item);
      var panel = panelFor(item);

      item.addEventListener('mouseenter', function () {
        scheduleOpen(item);
      });

      if (panel) {
        panel.addEventListener('mouseenter', clearTimers);
      }

      if (!trigger) return;

      trigger.addEventListener('click', function () {
        if (current === item) {
          closeAll(true);
          return;
        }
        clearTimers();
        open(item);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          clearTimers();
          open(item);
          var first = panel && panel.querySelector('a[href]');
          if (first) first.focus();
        }
      });
    });

    /* Leaving the header entirely is the only pointer gesture that closes. */
    header.addEventListener('mouseleave', scheduleClose);
    header.addEventListener('mouseenter', clearTimers);

    /* Tabbing onto a trigger must not open its menu — the brief reserves that
       for Enter, Space and ArrowDown. Focus only *sustains* a panel that is
       already open, which is also what stops Escape's focus restore from
       immediately reopening what it just closed. */
    header.addEventListener('focusin', function (event) {
      var item = event.target.closest(selectors.megaItem);
      if (current && item === current) {
        clearTimers();
        return;
      }
      if (current) closeAll(true);
    });

    header.addEventListener('focusout', function (event) {
      if (!header.contains(event.relatedTarget)) closeAll(true);
    });

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !current) return;
      var trigger = triggerFor(current);
      closeAll(true);
      if (trigger) trigger.focus();
    });

    document.addEventListener('click', function (event) {
      if (current && !header.contains(event.target)) closeAll(true);
    });
  })();

  /* Announcement rotation — mobile only ------------------------------------- */

  (function setUpAnnouncements() {
    var bar = document.querySelector(selectors.announcementBar);
    if (!bar || !bar.hasAttribute('data-announcement-rotate')) return;

    var items = Array.prototype.slice.call(bar.querySelectorAll(selectors.announcementItem));
    if (items.length < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 990px)');
    var seconds = parseInt(bar.getAttribute('data-announcement-rotate'), 10) || 5;
    var index = 0;
    var timer = null;

    function show(next) {
      items.forEach(function (item, i) {
        if (i === next) {
          item.removeAttribute('data-announcement-hidden');
        } else {
          item.setAttribute('data-announcement-hidden', '');
        }
      });
      index = next;
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function sync() {
      stop();
      /* Desktop shows all three at once, and a reduced-motion preference means
         no unattended movement at all — in both cases the first message simply
         stays put. */
      if (desktop.matches || reduceMotion.matches) {
        show(0);
        return;
      }
      timer = window.setInterval(function () {
        show((index + 1) % items.length);
      }, seconds * 1000);
    }

    sync();
    ['change'].forEach(function (event) {
      desktop.addEventListener(event, sync);
      reduceMotion.addEventListener(event, sync);
    });
  })();

  /* Mobile navigation accordions -------------------------------------------- */

  document.querySelectorAll(selectors.mobileAccordionToggle).forEach(function (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    var closeTimer = null;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      window.clearTimeout(closeTimer);

      if (open) {
        /* Collapse first, then hide — hiding immediately would cut the
           animation off at the first frame. */
        panel.classList.remove('is-open');
        closeTimer = window.setTimeout(function () {
          if (!panel.classList.contains('is-open')) panel.hidden = true;
        }, 240);
        return;
      }

      /* And on the way in, the panel has to be laid out before the class
         lands or there is no start value for the transition to run from. */
      panel.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
      });
    });
  });

  /* Country / currency selector --------------------------------------------- */

  document.querySelectorAll(selectors.localeRoot).forEach(function (root) {
    var toggle = root.querySelector(selectors.localeToggle);
    var panel = root.querySelector(selectors.localePanel);
    if (!toggle || !panel) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setOpen(false);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setOpen(false);
      toggle.focus();
    });
  });
})();

/* ==========================================================================
   Phase N.2 — Master adaptive PLP sidebar
   Three behaviours, all progressive: a group's tail expands, a long group can
   be typed against, and the desktop sidebar applies on change so the submit
   button is only ever the no-JS path. The drawer keeps its explicit Apply.
   ========================================================================== */
(function () {
  'use strict';

  var strings = (window.Y10 && window.Y10.strings) || {};

  /* View all / view less ---------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-filter-more]');
    if (!more) return;

    var group = more.closest('[data-filter-group]');
    if (!group) return;

    var expanded = more.getAttribute('aria-expanded') === 'true';
    group.classList.toggle('is-expanded', !expanded);
    more.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    var label = more.querySelector('[data-filter-more-label]');
    if (label) {
      label.textContent = expanded
        ? strings.filterViewAll || 'View all'
        : strings.filterViewLess || 'View less';
    }
  });

  /* Type-ahead within one group -------------------------------------------- */
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-filter-search]');
    if (!input) return;

    var group = input.closest('[data-filter-group]');
    if (!group) return;

    var query = input.value.trim().toLowerCase();
    var rows = group.querySelectorAll('[data-filter-row]');

    /* Typing widens the group past its collapsed tail, otherwise a match in
       the hidden remainder would look like no match at all. */
    group.classList.toggle('is-expanded', query.length > 0);

    Array.prototype.forEach.call(rows, function (row) {
      var label = row.querySelector('[data-filter-label]');
      var text = label ? label.textContent.toLowerCase() : '';
      row.classList.toggle('is-filtered-out', query.length > 0 && text.indexOf(query) === -1);
    });
  });

  /* An empty field still submits its key, which leaves `filter.v.price.gte=`
     hanging off every filtered URL. Emptying one is how you clear it, so the
     field is disabled for the length of the submit rather than cleared. */
  function dropEmptyFields(form) {
    Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (input) {
      if (input.value.trim() === '') input.disabled = true;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-collection-filter-form]');
    if (form) dropEmptyFields(form);
  });

  /* Filters apply on change ------------------------------------------------
     Both surfaces, no Apply step. The drawer reopens itself after the reload
     so a customer can keep narrowing without hunting for the button again.
  ------------------------------------------------------------------------- */

  var DRAWER_FLAG = 'y10:collection-filters-open';

  function submitFilters(form) {
    if (form.closest('[data-collection-filter-drawer]')) {
      try {
        sessionStorage.setItem(DRAWER_FLAG, '1');
      } catch (error) {
        /* Private mode: the drawer simply will not reopen. */
      }
    }

    dropEmptyFields(form);
    form.submit();
  }

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-collection-filter-form]');
    if (!form) return;
    if (!event.target.matches('input, select')) return;

    /* Sample rows are review-only. They carry no name, so they would submit
       nothing anyway — reloading the page on their account would just discard
       the selection the reviewer is looking at. */
    if (event.target.matches('[data-placeholder-input]')) return;

    /* The range handles have their own commit below; letting the generic
       handler through as well would submit the form twice. */
    if (event.target.matches('[data-price-range]')) return;

    submitFilters(form);
  });

  /* Price range -------------------------------------------------------------
     Two range inputs, two number fields and one filled track, all describing
     the same pair of numbers. Whichever the customer touches, the other two
     follow; only the number fields carry a name, so only they submit.
  ------------------------------------------------------------------------- */

  function priceParts(el) {
    var wrapper = el.closest('[data-price-filter]');
    if (!wrapper) return null;

    var max = parseFloat(wrapper.getAttribute('data-range-max'));
    if (!max || max <= 0) return null;

    return {
      wrapper: wrapper,
      max: max,
      track: wrapper.querySelector('[data-price-track]'),
      minField: wrapper.querySelector('[data-price-input="min"]'),
      maxField: wrapper.querySelector('[data-price-input="max"]'),
      minRange: wrapper.querySelector('[data-price-range="min"]'),
      maxRange: wrapper.querySelector('[data-price-range="max"]')
    };
  }

  /* The two values are read back from whichever control is authoritative, then
     ordered, so dragging one handle past the other swaps rather than inverts
     the selection. */
  function priceValues(p, source) {
    var from;
    var to;

    if (source === 'range') {
      from = parseFloat(p.minRange.value);
      to = parseFloat(p.maxRange.value);
    } else {
      from = p.minField && p.minField.value !== '' ? parseFloat(p.minField.value) : 0;
      to = p.maxField && p.maxField.value !== '' ? parseFloat(p.maxField.value) : p.max;
    }

    if (isNaN(from)) from = 0;
    if (isNaN(to)) to = p.max;

    from = Math.max(0, Math.min(p.max, from));
    to = Math.max(0, Math.min(p.max, to));

    if (from > to) {
      var swap = from;
      from = to;
      to = swap;
    }

    return { from: from, to: to };
  }

  function paintPrice(p, v) {
    if (!p.track) return;
    p.track.style.setProperty('--price-from', (v.from / p.max) * 100 + '%');
    p.track.style.setProperty('--price-to', (v.to / p.max) * 100 + '%');
  }

  /* A bound that is still at the end of the range is not a filter, so it is
     left empty rather than submitted as "from 0" or "to the highest price". */
  function writePriceFields(p, v) {
    if (p.minField) p.minField.value = v.from > 0 ? String(v.from) : '';
    if (p.maxField) p.maxField.value = v.to < p.max ? String(v.to) : '';
  }

  function writePriceRanges(p, v) {
    if (p.minRange) p.minRange.value = String(v.from);
    if (p.maxRange) p.maxRange.value = String(v.to);
  }

  document.addEventListener('input', function (event) {
    var range = event.target.closest('[data-price-range]');
    if (range) {
      var pr = priceParts(range);
      if (!pr) return;
      var vr = priceValues(pr, 'range');
      paintPrice(pr, vr);
      writePriceFields(pr, vr);
      return;
    }

    var field = event.target.closest('[data-price-input]');
    if (!field) return;

    var pf = priceParts(field);
    if (!pf) return;
    var vf = priceValues(pf, 'field');
    paintPrice(pf, vf);
    writePriceRanges(pf, vf);
  });

  /* Releasing a handle is the commit. Sliding is not. */
  document.addEventListener('change', function (event) {
    var range = event.target.closest('[data-price-range]');
    if (!range) return;

    var p = priceParts(range);
    if (!p) return;

    var v = priceValues(p, 'range');
    writePriceRanges(p, v);
    writePriceFields(p, v);

    var form = range.closest('[data-collection-filter-form]');
    if (!form) return;

    submitFilters(form);
  });

  /* Reopen the drawer after a filter reload, and forget the flag as soon as
     the customer closes it themselves. */
  function restoreFilterDrawer() {
    var wanted;
    try {
      wanted = sessionStorage.getItem(DRAWER_FLAG);
    } catch (error) {
      return;
    }
    if (!wanted) return;

    var trigger = document.querySelector('[data-collection-filter-open]');
    if (!trigger || trigger.offsetParent === null) {
      /* The sidebar is showing instead, so there is no drawer to restore. */
      try {
        sessionStorage.removeItem(DRAWER_FLAG);
      } catch (error) {}
      return;
    }

    trigger.click();
  }

  function forgetFilterDrawer() {
    try {
      sessionStorage.removeItem(DRAWER_FLAG);
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-collection-filter-close]')) forgetFilterDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') forgetFilterDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreFilterDrawer);
  } else {
    restoreFilterDrawer();
  }
})();
